/* eslint-disable */
export const arrayUnicode1 = [
  [ 0x0001f600 ], // 😀 
  [ 0x0001f603 ], // 😃 
  [ 0x0001f604 ], // 😄 
  [ 0x0001f601 ], // 😁 
  [ 0x0001f606 ], // 😆 
  [ 0x0001f605 ], // 😅 
  [ 0x0001f602 ], // 😂 
  [ 0x0001f923 ], // 🤣 
  [ 0x0001f972 ], // 🥲
  [ 0x263a ], // 
  [ 0x0001f60a ], // 😊 
  [ 0x0001f607 ], // 😇 
  [ 0x0001f642 ], // 🙂 
  [ 0x0001f643 ], // 🙃 
  [ 0x0001f609 ], // 😉 
  [ 0x0001f60c ], // 😌 
  [ 0x0001f60d ], // 😍 
  [ 0x0001F970 ], // 🥰 
  [ 0x0001f618 ], // 😘 
  [ 0x0001f617 ], // 😗 
  [ 0x0001f619 ], // 😙 
  [ 0x0001f61a ], // 😚 
  [ 0x0001f60b ], // 😋 
  [ 0x0001f61b ], // 😛 
  [ 0x0001f61d ], // 😝 
  [ 0x0001f61c ], // 😜 
  [ 0x0001F92A ], // 🤪 
  [ 0x0001F928 ], // 🤨 
  [ 0x0001F9D0 ], // 🧐 
  [ 0x0001f913 ], // 🤓 
  [ 0x0001f60e ], // 😎 
  [ 0x0001F978 ], // 🥸
  [ 0x0001F929 ], // 🤩 
  [ 0x0001F973 ], // 🥳 
  [ 0x0001f60f ], // 😏 
  [ 0x0001f612 ], // 😒 
  [ 0x0001f61e ], // 😞 
  [ 0x0001f614 ], // 😔 
  [ 0x0001f61f ], // 😟 
  [ 0x0001f615 ], // 😕 
  [ 0x0001f641 ], // 🙁 
  [ 0x2639 ], // ☹️ 
  [ 0x0001f623 ], // 😣 
  [ 0x0001f616 ], // 😖 
  [ 0x0001f62b ], // 😫 
  [ 0x0001f629 ], // 😩 
  [ 0x0001F97A ], // 🥺 
  [ 0x0001f622 ], // 😢 
  [ 0x0001f62d ], // 😭 
  [ 0x0001f624 ], // 😤 
  [ 0x0001f620 ], // 😠 
  [ 0x0001f621 ], // 😡 
  [ 0x0001F92C ], // 🤬 
  [ 0x0001F92F ], // 🤯 
  [ 0x0001f633 ], // 😳 
  [ 0x0001F975 ], // 🥵 
  [ 0x0001F976 ], // 🥶 
  [ 0x0001f631 ], // 😱 
  [ 0x0001f628 ], // 😨 
  [ 0x0001f630 ], // 😰 
  [ 0x0001f625 ], // 😥 
  [ 0x0001f613 ], // 😓 
  [ 0x0001f917 ], // 🤗 
  [ 0x0001f914 ], // 🤔 
  [ 0x0001F92D ], // 🤭 
  [ 0x0001F92B ], // 🤫 
  [ 0x0001f925 ], // 🤥 
  [ 0x0001f636 ], // 😶 
  [ 0x0001f610 ], // 😐 
  [ 0x0001f611 ], // 😑 
  [ 0x0001f62c ], // 😬 
  [ 0x0001f644 ], // 🙄 
  [ 0x0001f62f ], // 😯 
  [ 0x0001f626 ], // 😦 
  [ 0x0001f627 ], // 😧 
  [ 0x0001f62e ], // 😮 
  [ 0x0001f632 ], // 😲 
  [ 0x0001f971 ], // 🥱
  [ 0x0001f634 ], // 😴 
  [ 0x0001f924 ], // 🤤 
  [ 0x0001f62a ], // 😪 
  [ 0x0001f635 ], // 😵 
  [ 0x0001f910 ], // 🤐 
  [ 0x0001F974 ], // 🥴 
  [ 0x0001f922 ], // 🤢 
  [ 0x0001F92E ], // 🤮 
  [ 0x0001f927 ], // 🤧 
  [ 0x0001f637 ], // 😷 
  [ 0x0001f912 ], // 🤒 
  [ 0x0001f915 ], // 🤕 
  [ 0x0001f911 ], // 🤑 
  [ 0x0001f920 ], // 🤠 
  [ 0x0001f608 ], // 😈 
  [ 0x0001f47f ], // 👿 
  [ 0x0001f479 ], // 👹 
  [ 0x0001f47a ], // 👺 
  [ 0x0001f921 ], // 🤡 
  [ 0x0001f4a9 ], // 💩 
  [ 0x0001f47b ], // 👻 
  [ 0x0001f480 ], // 💀 
  [ 0x00002620, 0x0000fe0f ], // ☠️ 
  [ 0x0001f47d ], // 👽 
  [ 0x0001f47e ], // 👾 
  [ 0x0001f916 ], // 🤖 
  [ 0x0001f383 ], // 🎃 
  [ 0x0001f63a ], // 😺 
  [ 0x0001f638 ], // 😸 
  [ 0x0001f639 ], // 😹 
  [ 0x0001f63b ], // 😻 
  [ 0x0001f63c ], // 😼 
  [ 0x0001f63d ], // 😽 
  [ 0x0001f640 ], // 🙀 
  [ 0x0001f63f ], // 😿 
  [ 0x0001f63e ], // 😾 
  [ 0x0001F932 ], // 🤲 
  [ 0x0001f450 ], // 👐 
  [ 0x0001f64c ], // 🙌 
  [ 0x0001f44f ], // 👏 
  [ 0x0001f91d ], // 🤝 
  [ 0x0001f44d ], // 👍 
  [ 0x0001f44e ], // 👎 
  [ 0x0001f44a ], // 👊 
  [ 0x0000270a ], // ✊ 
  [ 0x0001f91b ], // 🤛 
  [ 0x0001f91c ], // 🤜 
  [ 0x0001f91e ], // 🤞 
  [ 0x0000270c ], // 
  [ 0x0001F91F ], // 🤟 
  [ 0x0001f918 ], // 🤘 
  [ 0x0001f44c ], // 👌
  [ 0x0001f90c ], // 🤌
  [ 0x0001f90f ], // 🤏
  [ 0x0001f448 ], // 👈 
  [ 0x0001f449 ], // 👉 
  [ 0x0001f446 ], // 👆 
  [ 0x0001f447 ], // 👇 
  [ 0x0000261d ], // ☝️ 
  [ 0x0000270b ], // ✋ 
  [ 0x0001f91a ], // 🤚 
  [ 0x0001f590 ], // 🖐️ 
  [ 0x0001f596 ], // 🖖 
  [ 0x0001f44b ], // 👋 
  [ 0x0001f919 ], // 🤙 
  [ 0x0001f4aa ], // 💪 
  [ 0x0001F9BE ], // 🦾
  [ 0x0001f595 ], // 🖕 
  [ 0x0000270d ], // ✍️ 
  [ 0x0001f64f ], // 🙏 
  [ 0x0001F9B6 ], // 🦶 
  [ 0x0001F9B5 ], // 🦵 
  [ 0x0001F9BF ], // 🦿
  [ 0x0001f484 ], // 💄 
  [ 0x0001f48b ], // 💋 
  [ 0x0001f444 ], // 👄 
  [ 0x0001F9B7 ], // 🦷 
  [ 0x0001f445 ], // 👅 
  [ 0x0001f442 ], // 👂 
  [ 0x0001f9BB ], // 🦻
  [ 0x0001f443 ], // 👃 
  [ 0x0001f463 ], // 👣 
  [ 0x0001f441, 0x0000fe0f ], // 👁️ 
  [ 0x0001f440 ], // 👀 
  [ 0x0001fac0 ], // 🫀
  [ 0x0001fac1 ], // 🫁
  [ 0x0001F9E0 ], // 🧠
  [ 0x0001f5e3, 0x0000fe0f ], // 🗣️ 
  [ 0x0001f464 ], // 👤 
  [ 0x0001f465 ], // 👥 
  [ 0x0001fac2 ], // 🫂
  [ 0x0001f476 ], // 👶 
  [ 0x0001f467 ], // 👧 
  [ 0x0001F9D2 ], // 🧒 
  [ 0x0001f466 ], // 👦 
  [ 0x0001f469 ], // 👩 
  [ 0x0001F9D1 ], // 🧑 
  [ 0x0001f468 ], // 👨 
  [ 0x0001F469, 0x0000200d, 0x0001F9B1 ], // 👩‍🦱 
  [ 0x0001F9D1, 0x0000200d, 0x0001F9B1 ], // 🧑‍🦱 
  [ 0x0001F468, 0x0000200d, 0x0001F9B1 ], // 👨‍🦱 
  [ 0x0001F469, 0x0000200d, 0x0001F9B0 ], // 👩‍🦰 
  [ 0x0001F9D1, 0x0000200d, 0x0001F9B0 ], // 🧑‍🦰 
  [ 0x0001F468, 0x0000200d, 0x0001F9B0 ], // 👨‍🦰 
  [ 0x0001f471, 0x0000200d, 0x00002640, 0x0000fe0f ], // 👱‍♀️ 
  [ 0x0001f471 ], // 👱 
  [ 0x0001f471, 0x0000200d, 0x00002642, 0x0000fe0f ], // 👱‍♂️
  [ 0x0001F469, 0x0000200d, 0x0001F9B3 ], // 👩‍🦳 
  [ 0x0001F9D1, 0x0000200d, 0x0001F9B3 ], // 🧑‍🦳
  [ 0x0001F468, 0x0000200d, 0x0001F9B3 ], // 👨‍🦳 
  [ 0x0001F469, 0x0000200d, 0x0001F9B2 ], // 👩‍🦲 
  [ 0x0001F9D1, 0x0000200d, 0x0001F9B2 ], // 🧑‍🦲
  [ 0x0001F468, 0x0000200d, 0x0001F9B2 ], // 👨‍🦲 
  [ 0x0001F9D4 ], // 🧔 
  [ 0x0001f475 ], // 👵 
  [ 0x0001F9D3 ], // 🧓 
  [ 0x0001f474 ], // 👴 
  [ 0x0001f472 ], // 👲 
  [ 0x0001f473, 0x0000200d, 0x00002640, 0x0000fe0f ], // 👳‍♀️ 
  [ 0x0001f473 ], // 👳 
  [ 0x0001f473, 0x0000200d, 0x00002642, 0x0000fe0f ], // 👳‍♀️ 
  [ 0x0001F9D5 ], // 🧕 
  [ 0x0001f46e, 0x0000200d, 0x00002640, 0x0000fe0f ], // 👮‍♀️ 
  [ 0x0001f46e ], // 👮 
  [ 0x0001f46e, 0x0000200d, 0x00002642, 0x0000fe0f ], // 👮‍♂️
  [ 0x0001f477, 0x0000200d, 0x00002640, 0x0000fe0f ], // 👷‍♀️ 
  [ 0x0001f477 ], // 👷 
  [ 0x0001f477, 0x0000200d, 0x00002642, 0x0000fe0f ], // 👷‍♀️ 
  [ 0x0001f482, 0x0000200d, 0x00002640, 0x0000fe0f ], // 💂‍♀️ 
  [ 0x0001f482 ], // 💂 
  [ 0x0001f482, 0x0000200d, 0x00002642, 0x0000fe0f ], // 💂‍♀️ 
  [ 0x0001f575, 0x0000fe0f, 0x0000200d, 0x00002640, 0x0000FE0F ], // 🕵️‍♀️ 
  [ 0x0001f575 ], // 🕵
  [ 0x0001f575, 0x0000fe0f, 0x0000200d, 0x00002642, 0x0000FE0F ], // 🕵️‍♂️ 
  [ 0x0001f469, 0x0000200D, 0x00002695, 0x0000fe0f ], // 👩‍⚕️ 
  [ 0x0001f9D1, 0x0000200D, 0x00002695, 0x0000fe0f ], // 🧑‍⚕️ 
  [ 0x0001f468, 0x0000200D, 0x00002695, 0x0000fe0f ], // 👨‍⚕️ 
  [ 0x0001F469, 0x0000200D, 0x0001F33E ], // 👩‍🌾 
  [ 0x0001F9D1, 0x0000200D, 0x0001F33E ], // 🧑‍🌾
  [ 0x0001F468, 0x0000200D, 0x0001F33E ], // 👨‍🌾 
  [ 0x0001F469, 0x0000200D, 0x0001F373 ], // 👩‍🍳 
  [ 0x0001F9D1, 0x0000200D, 0x0001F373 ], // 🧑‍🍳
  [ 0x0001F468, 0x0000200D, 0x0001F373 ], // 👨‍🍳 
  [ 0x0001F469, 0x0000200D, 0x0001F393 ], // 👩‍🎓 
  [ 0x0001F9D1, 0x0000200D, 0x0001F393 ], // 🧑‍🎓
  [ 0x0001F468, 0x0000200D, 0x0001F393 ], // 👨‍🎓 
  [ 0x0001F469, 0x0000200D, 0x0001F3A4 ], // 👩‍🎤 
  [ 0x0001F9D1, 0x0000200D, 0x0001F3A4 ], // 🧑‍🎤
  [ 0x0001F468, 0x0000200D, 0x0001F3A4 ], // 👨‍🎤 
  [ 0x0001F469, 0x0000200D, 0x0001F3EB ], // 👩‍🏫 
  [ 0x0001F9D1, 0x0000200D, 0x0001F3EB ], // 🧑‍🏫
  [ 0x0001F468, 0x0000200D, 0x0001F3EB ], // 👨‍🏫 
  [ 0x0001F469, 0x0000200D, 0x0001F3ED ], // 👩‍🏭 
  [ 0x0001F9D1, 0x0000200D, 0x0001F3ED ], // 🧑‍🏭
  [ 0x0001F468, 0x0000200D, 0x0001F3ED ], // 👨‍🏭 
  [ 0x0001F469, 0x0000200D, 0x0001F4BB ], // 👩‍💻 
  [ 0x0001F9D1, 0x0000200D, 0x0001F4BB ], // 🧑‍💻
  [ 0x0001F468, 0x0000200D, 0x0001F4BB ], // 👨‍💻 
  [ 0x0001F469, 0x0000200D, 0x0001F4BC ], // 👩‍💼 
  [ 0x0001F9D1, 0x0000200D, 0x0001F4BC ], // 🧑‍💼
  [ 0x0001F468, 0x0000200D, 0x0001F4BC ], // 👨‍💼 
  [ 0x0001F469, 0x0000200D, 0x0001F527 ], // 👩‍🔧 
  [ 0x0001F9D1, 0x0000200D, 0x0001F527 ], // 🧑‍🏭
  [ 0x0001F468, 0x0000200D, 0x0001F527 ], // 👨‍🔧 
  [ 0x0001F469, 0x0000200D, 0x0001F52C ], // 👩‍🔬 
  [ 0x0001F9D1, 0x0000200D, 0x0001F52C ], // 👩‍🔬 
  [ 0x0001F468, 0x0000200D, 0x0001F52C ], // 👨‍🔬 
  [ 0x0001F469, 0x0000200D, 0x0001F3A8 ], // 👩‍🎨 
  [ 0x0001F9D1, 0x0000200D, 0x0001F3A8 ], // 🧑‍🎨
  [ 0x0001F468, 0x0000200D, 0x0001F3A8 ], // 👨‍🎨 
  [ 0x0001F469, 0x0000200D, 0x0001F692 ], // 👩‍🚒 
  [ 0x0001F9D1, 0x0000200D, 0x0001F692 ], // 🧑‍🚒
  [ 0x0001F468, 0x0000200D, 0x0001F692 ], // 👨‍🚒 
  [ 0x0001F469, 0x0000200D, 0x00002708, 0x0000FE0F ], // 👩‍✈️ 
  [ 0x0001F9D1, 0x0000200D, 0x00002708, 0x0000FE0F ], // 🧑‍✈️
  [ 0x0001F468, 0x0000200D, 0x00002708, 0x0000FE0F ], // 👨‍✈️ 
  [ 0x0001F469, 0x0000200D, 0x0001F680 ], // 👩‍🚀 
  [ 0x0001F9D1, 0x0000200D, 0x0001F680 ], // 🧑‍🚀
  [ 0x0001F468, 0x0000200D, 0x0001F680 ], // 👨‍🚀 
  [ 0x0001F469, 0x0000200D, 0x00002696, 0x0000FE0F ], // 👩‍⚖️ 
  [ 0x0001F9D1, 0x0000200D, 0x00002696, 0x0000FE0F ], // 🧑‍⚖️
  [ 0x0001F468, 0x0000200D, 0x00002696, 0x0000FE0F ], // 👨‍⚖️ 
  [ 0x0001F470, 0x0000200D, 0x00002640, 0x000FE0F] , // 👰‍♀️
  [ 0x0001f470 ], // 👰
  [ 0x0001F470, 0x0000200D, 0x00002642, 0x000FE0F] , // 👰‍♂️
  [ 0x0001F935, 0x0000200D, 0x00002640, 0x000FE0F] , // 🤵‍♀️
  [ 0x0001F935 ], // 🤵
  [ 0x0001F935, 0x0000200D, 0x00002642, 0x000FE0F] , // 🤵‍♂️
  [ 0x0001f478 ], // 👸 
  [ 0x0001F934 ], // 🤴
  [ 0x0001F977 ], // 🥷
  [ 0x0001F9B8, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🦸‍♀️ 
  [ 0x0001F9B8 ], // 🦸
  [ 0x0001F9B8, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🦸‍♂️ 
  [ 0x0001F9B9, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🦹‍♀️ 
  [ 0x0001F9B9 ], // 🦹
  [ 0x0001F9B9, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🦹‍♂️ 
  [ 0x0001F936 ], // 🤶
  [ 0x0001F9D1, 0x0000200D, 0x0001F384 ], // 🧑‍🎄
  [ 0x0001f385 ], // 🎅 
  [ 0x0001F9D9, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧙‍♀️
  [ 0x0001F9D9 ], // 🧙 
  [ 0x0001F9D9, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧙‍♂️ 
  [ 0x0001F9DD, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧝‍♀️ 
  [ 0x0001F9DD ], // 🧝 
  [ 0x0001F9DD, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧝‍♂️
  [ 0x0001F9DB, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧛‍♀️
  [ 0x0001F9DB ], // 🧛 
  [ 0x0001F9DB, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧛‍♂️ 
  [ 0x0001F9DF, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧟‍♀️ 
  [ 0x0001F9DF ], // 🧟 
  [ 0x0001F9DF, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧟‍♀️ 
  [ 0x0001F9DE, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧞‍♀️ 
  [ 0x0001F9DE ], // 🧞 
  [ 0x0001F9DE, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧞‍♀️ 
  [ 0x0001F9DC, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧜‍♀️ 
  [ 0x0001F9DC ], // 🧜 
  [ 0x0001F9DC, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧜‍♂️
  [ 0x0001F9DA, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧚‍♀️ 
  [ 0x0001F9DA ], // 🧚 
  [ 0x0001F9DA, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧚‍♂️ 
  [ 0x0001f47c ], // 👼 
  [ 0x0001F930 ], // 🤰 
  [ 0x0001F931 ], // 🤱
  [ 0x0001F469, 0x0000200D, 0x0001F37C ], // 👩‍🍼
  [ 0x0001F9d1, 0x0000200D, 0x0001F37C ], // 🧑‍🍼
  [ 0x0001F468, 0x0000200D, 0x0001F37C ], // 👨‍🍼
  [ 0x0001f647, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🙇‍♀️ 
  [ 0x0001f647 ], // 🙇 
  [ 0x0001f647, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🙇‍♂️ 
  [ 0x0001f481, 0x0000200d, 0x00002640, 0x0000fe0f ], // 💁‍♀️
  [ 0x0001f481 ], // 💁 
  [ 0x0001f481, 0x0000200d, 0x00002642, 0x0000fe0f ], // 💁‍♂️ 
  [ 0x0001f645, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🙅‍♀️ 
  [ 0x0001f645 ], // 🙅 
  [ 0x0001f645, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🙅‍♂️ 
  [ 0x0001f646, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🙆‍♀️
  [ 0x0001f646 ], // 🙆 
  [ 0x0001f646, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🙆‍♂️ 
  [ 0x0001f64b, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🙋‍♀️
  [ 0x0001f64b ], // 🙋 
  [ 0x0001f64b, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🙋‍♂️
  [ 0x0001F9cf, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧏‍♀️ 
  [ 0x0001F9cf ], // 🧏
  [ 0x0001F9cf, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧏‍♂️
  [ 0x0001F926, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🤦‍♀️ 
  [ 0x0001F926 ], // 🤦 
  [ 0x0001F926, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🤦‍♂️
  [ 0x0001F937, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🤷‍♀️  
  [ 0x0001F937 ], // 🤷 
  [ 0x0001F937, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🤷‍♂️ 
  [ 0x0001f64e, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🙎‍♀️
  [ 0x0001f64e ], // 🙎 
  [ 0x0001f64e, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🙎‍♂️ 
  [ 0x0001f64d, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🙍‍♀️
  [ 0x0001f64d ], // 🙍 
  [ 0x0001f64d, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🙍‍♂️ 
  [ 0x0001f487, 0x0000200d, 0x00002640, 0x0000fe0f ], // 💇‍♀️
  [ 0x0001f487 ], // 💇 
  [ 0x0001f487, 0x0000200d, 0x00002642, 0x0000fe0f ], // 💇‍♂️ 
  [ 0x0001f486, 0x0000200d, 0x00002640, 0x0000fe0f ], // 💆‍♀️
  [ 0x0001f486 ], // 💆 
  [ 0x0001f486, 0x0000200d, 0x00002642, 0x0000fe0f ], // 💆‍♂️ 
  [ 0x0001F9D6, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧖‍♀️ 
  [ 0x0001F9D6 ], // 🧖 
  [ 0x0001F9D6, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧖‍♂️
  [ 0x0001f485 ], // 💅 
  [ 0x0001f933 ], // 🤳 
  [ 0x0001f483 ], // 💃 
  [ 0x0001F57A ], // 🕺 
  [ 0x0001f46f, 0x0000200d, 0x00002640, 0x0000fe0f ], // 👯‍♀️ 
  [ 0x0001f46f ], // 👯 
  [ 0x0001f46f, 0x0000200d, 0x00002642, 0x0000fe0f ], // 👯‍♂️ 
  [ 0x0001f574 ], // 🕴 
  [ 0x0001F9D1, 0x0000200D, 0x0001F9BD ], // 🧑‍🦽
  [ 0x0001F468, 0x0000200D, 0x0001F9BD ], // 👨‍🦽
  [ 0x0001F469, 0x0000200D, 0x0001F9BD ], // 👩‍🦽
  [ 0x0001F9D1, 0x0000200D, 0x0001F9BC ], // 🧑‍🦼
  [ 0x0001F468, 0x0000200D, 0x0001F9BC ], // 👨‍🦼
  [ 0x0001F469, 0x0000200D, 0x0001F9BC ], // 👩‍🦼
  [ 0x0001f6b6, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🚶‍♀️ 
  [ 0x0001f6b6 ], // 🚶 
  [ 0x0001f6b6, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🚶‍♀️ 
  [ 0x0001F469, 0x0000200D, 0x0001F9AF ], // 👩‍🦯
  [ 0x0001F9D1, 0x0000200D, 0x0001F9AF ], // 🧑‍🦯
  [ 0x0001F468, 0x0000200D, 0x0001F9AF ], // 👨‍🦯
  [ 0x0001F9CE, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🧎‍♀️
  [ 0x0001F9CE ], // 🧎
  [ 0x0001F9CE, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🧎‍♂️	
  [ 0x0001f3c3, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🏃‍♀️ 
  [ 0x0001f3c3 ], // 🏃 
  [ 0x0001f3c3, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🏃‍♂️ 
  [ 0x0001F9CD, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🧍‍♀️
  [ 0x0001F9CD ], // 🧍
  [ 0x0001F9CD, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🧍‍♂️
  [ 0x0001f46b ], // 👫 
  [ 0x0001f46d ], // 👭 
  [ 0x0001f46c ], // 👬 
  [ 0x0001f469, 0x0000200d, 0x00002764, 0x0000fe0f, 0x0000200d, 0x0001f468 ], // 👩‍❤️‍👨 
  [ 0x0001f469, 0x0000200d, 0x00002764, 0x0000fe0f, 0x0000200d, 0x0001f469 ], // 👩‍❤️‍👩 
  [ 0x0001f468, 0x0000200d, 0x00002764, 0x0000fe0f, 0x0000200d, 0x0001f468 ], // 👨‍❤️‍👨 
  [ 0x0001f469, 0x0000200d, 0x00002764, 0x0000fe0f, 0x0000200d, 0x0001f48b, 0x0000200d, 0x0001f468 ], // 👩‍❤️‍💋‍👨 
  [ 0x0001f469, 0x0000200d, 0x00002764, 0x0000fe0f, 0x0000200d, 0x0001f48b, 0x0000200d, 0x0001f469 ], // 👩‍❤️‍💋‍👩 
  [ 0x0001f468, 0x0000200d, 0x00002764, 0x0000fe0f, 0x0000200d, 0x0001f48b, 0x0000200d, 0x0001f468 ], // 👨‍❤️‍💋‍👨 
  [ 0x0001f468, 0x0000200d, 0x0001f469, 0x0000200d, 0x0001f466 ], // 👨‍👩‍👦 
  [ 0x0001f468, 0x0000200d, 0x0001f469, 0x0000200d, 0x0001f467 ], // 👨‍👩‍👧 
  [ 0x0001f468, 0x0000200d, 0x0001f469, 0x0000200d, 0x0001f467, 0x0000200d, 0x0001f466 ], // 👨‍👩‍👧‍👦 
  [ 0x0001f468, 0x0000200d, 0x0001f469, 0x0000200d, 0x0001f466, 0x0000200d, 0x0001f466 ], // 👨‍👩‍👦‍👦 
  [ 0x0001f468, 0x0000200d, 0x0001f469, 0x0000200d, 0x0001f467, 0x0000200d, 0x0001f467 ], // 👨‍👩‍👧‍👧 
  [ 0x0001f469, 0x0000200d, 0x0001f469, 0x0000200d, 0x0001f466 ], // 👩‍👩‍👦 
  [ 0x0001f469, 0x0000200d, 0x0001f469, 0x0000200d, 0x0001f467 ], // 👩‍👩‍👧 
  [ 0x0001f469, 0x0000200d, 0x0001f469, 0x0000200d, 0x0001f467, 0x0000200d, 0x0001f466 ], // 👩‍👩‍👧‍👦 
  [ 0x0001f469, 0x0000200d, 0x0001f469, 0x0000200d, 0x0001f466, 0x0000200d, 0x0001f466 ], // 👩‍👩‍👦‍👦 
  [ 0x0001f469, 0x0000200d, 0x0001f469, 0x0000200d, 0x0001f467, 0x0000200d, 0x0001f467 ], // 👩‍👩‍👧‍👧 
  [ 0x0001f468, 0x0000200d, 0x0001f468, 0x0000200d, 0x0001f466 ], // 👨‍👨‍👦 
  [ 0x0001f468, 0x0000200d, 0x0001f468, 0x0000200d, 0x0001f467 ], // 👨‍👨‍👧 
  [ 0x0001f468, 0x0000200d, 0x0001f468, 0x0000200d, 0x0001f467, 0x0000200d, 0x0001f466 ], // 👨‍👨‍👧‍👦 
  [ 0x0001f468, 0x0000200d, 0x0001f468, 0x0000200d, 0x0001f466, 0x0000200d, 0x0001f466 ], // 👨‍👨‍👦‍👦 
  [ 0x0001f468, 0x0000200d, 0x0001f468, 0x0000200d, 0x0001f467, 0x0000200d, 0x0001f467 ], // 👨‍👨‍👧‍👧 
  [ 0x0001f469, 0x0000200d, 0x0001f466 ], // 👩‍👦 
  [ 0x0001f469, 0x0000200d, 0x0001f467 ], // 👩‍👧 
  [ 0x0001f469, 0x0000200d, 0x0001f467, 0x0000200d, 0x0001f466 ], // 👩‍👧‍👦 
  [ 0x0001f469, 0x0000200d, 0x0001f466, 0x0000200d, 0x0001f466 ], // 👩‍👦‍👦 
  [ 0x0001f469, 0x0000200d, 0x0001f467, 0x0000200d, 0x0001f467 ], // 👩‍👧‍👧 
  [ 0x0001f468, 0x0000200d, 0x0001f466 ], // 👨‍👦 
  [ 0x0001f468, 0x0000200d, 0x0001f467 ], // 👨‍👧 
  [ 0x0001f468, 0x0000200d, 0x0001f467, 0x0000200d, 0x0001f466 ], // 👨‍👧‍👦 
  [ 0x0001f468, 0x0000200d, 0x0001f466, 0x0000200d, 0x0001f466 ], // 👨‍👦‍👦 
  [ 0x0001f468, 0x0000200d, 0x0001f467, 0x0000200d, 0x0001f467 ], // 👨‍👧‍👧 
  [ 0x0001Faa2 ], // 🪢
  [ 0x0001F9F6 ], // 🧶 
  [ 0x0001F9F5 ], // 🧵 
  [ 0x0001Faa1 ], // 🪡
  [ 0x0001F9E5 ], // 🧥 
  [ 0x0001F97C ], // 🥼 
  [ 0x0001F9BA ], // 🦺 
  [ 0x0001f45a ], // 👚 
  [ 0x0001f455 ], // 👕 
  [ 0x0001f456 ], // 👖 
  [ 0x0001fA72 ], // 🩲 
  [ 0x0001fA73 ], // 🩳 
  [ 0x0001f454 ], // 👔 
  [ 0x0001f457 ], // 👗 
  [ 0x0001f459 ], // 👙 
  [ 0x0001fA71 ], // 🩱
  [ 0x0001f458 ], // 👘 
  [ 0x0001f97B ], // 🥻
  [ 0x0001Fa74 ], // 🩴
  [ 0x0001F97F ], // 🥿 
  [ 0x0001f460 ], // 👠 
  [ 0x0001f461 ], // 👡 
  [ 0x0001f462 ], // 👢 
  [ 0x0001f45e ], // 👞 
  [ 0x0001f45f ], // 👟 
  [ 0x0001F97E ], // 🥾 
  [ 0x0001F9E6 ], // 🧦 
  [ 0x0001F9E4 ], // 🧤 
  [ 0x0001F9E3 ], // 🧣 
  [ 0x0001f3a9 ], // 🎩 
  [ 0x0001F9E2 ], // 🧢 
  [ 0x0001f452 ], // 👒 
  [ 0x0001f393 ], // 🎓 
  [ 0x000026d1, 0x0000fe0f ], // ⛑️ 
  [ 0x0001fa96 ], // 🪖
  [ 0x0001f451 ], // 👑 
  [ 0x0001f48d ], // 💍 
  [ 0x0001f45d ], // 👝 
  [ 0x0001f45b ], // 👛 
  [ 0x0001f45c ], // 👜 
  [ 0x0001f4bc ], // 💼 
  [ 0x0001f392 ], // 🎒 
  [ 0x0001F9F3 ], // 🧳 
  [ 0x0001f453 ], // 👓 
  [ 0x0001f576, 0x0000fe0f ], // 🕶️ 
  [ 0x0001F97D ], // 🥽 
  [ 0x0001f302 ], // 🌂 
]

export const arrayUnicode2 = [
  [ 0x0001f436 ], // 🐶 
  [ 0x0001f431 ], // 🐱 
  [ 0x0001f42d ], // 🐭 
  [ 0x0001f439 ], // 🐹 
  [ 0x0001f430 ], // 🐰 
  [ 0x0001F98A ], // 🦊 
  [ 0x0001f43b ], // 🐻 
  [ 0x0001f43c ], // 🐼 
  [ 0x0001F43B, 0x0000200D, 0x00002744, 0x0000FE0F ], // 🐻‍❄️
  [ 0x0001f428 ], // 🐨 
  [ 0x0001f42f ], // 🐯 
  [ 0x0001f981 ], // 🦁 
  [ 0x0001f42e ], // 🐮 
  [ 0x0001f437 ], // 🐷 
  [ 0x0001f43d ], // 🐽 
  [ 0x0001f438 ], // 🐸 
  [ 0x0001f435 ], // 🐵 
  [ 0x0001f648 ], // 🙈 
  [ 0x0001f649 ], // 🙉 
  [ 0x0001f64a ], // 🙊 
  [ 0x0001f412 ], // 🐒 
  [ 0x0001f414 ], // 🐔 
  [ 0x0001f427 ], // 🐧 
  [ 0x0001f426 ], // 🐦 
  [ 0x0001f424 ], // 🐤 
  [ 0x0001f423 ], // 🐣 
  [ 0x0001f425 ], // 🐥 
  [ 0x0001F986 ], // 🦆 
  [ 0x0001F985 ], // 🦅 
  [ 0x0001F989 ], // 🦉 
  [ 0x0001F987 ], // 🦇 
  [ 0x0001f43a ], // 🐺 
  [ 0x0001f417 ], // 🐗 
  [ 0x0001f434 ], // 🐴 
  [ 0x0001f984 ], // 🦄 
  [ 0x0001f41d ], // 🐝 
  [ 0x0001FAB1 ], // 🪱
  [ 0x0001f41b ], // 🐛 
  [ 0x0001F98B ], // 🦋 
  [ 0x0001f40c ], // 🐌 
  [ 0x0001f41a ], // 🐚 
  [ 0x0001f41e ], // 🐞 
  [ 0x0001f41c ], // 🐜 
  [ 0x0001FAB0 ], // 🪰
  [ 0x0001FAB2 ], // 🪲
  [ 0x0001FAB3 ], // 🪳
  [ 0x0001F99F ], // 🦟 
  [ 0x0001F997 ], // 🦗 
  [ 0x0001f577, 0x0000fe0f ], // 🕷️ 
  [ 0x0001f578, 0x0000fe0f ], // 🕸️ 
  [ 0x0001f982 ], // 🦂 
  [ 0x0001f422 ], // 🐢 
  [ 0x0001f40d ], // 🐍 
  [ 0x0001F98E ], // 🦎 
  [ 0x0001F996 ], // 🦖 
  [ 0x0001F995 ], // 🦕 
  [ 0x0001f419 ], // 🐙 
  [ 0x0001F991 ], // 🦑 
  [ 0x0001F990 ], // 🦐 
  [ 0x0001F99E ], // 🦞
  [ 0x0001f980 ], // 🦀 
  [ 0x0001f421 ], // 🐡 
  [ 0x0001f420 ], // 🐠 
  [ 0x0001f41f ], // 🐟 
  [ 0x0001f42c ], // 🐬 
  [ 0x0001f433 ], // 🐳 
  [ 0x0001f40b ], // 🐋 
  [ 0x0001F988 ], // 🦈 
  [ 0x0001F9AD ], // 🦭
  [ 0x0001f40a ], // 🐊 
  [ 0x0001f405 ], // 🐅 
  [ 0x0001f406 ], // 🐆 
  [ 0x0001F993 ], // 🦓 
  [ 0x0001F98D ], // 🦍 
  [ 0x0001F9A7 ], // 🦧
  [ 0x0001F9A3 ], // 🦣
  [ 0x0001f418 ], // 🐘 
  [ 0x0001F99B ], // 🦛 
  [ 0x0001F98F ], // 🦏 
  [ 0x0001f42a ], // 🐪 
  [ 0x0001f42b ], // 🐫 
  [ 0x0001F992 ], // 🦒 
  [ 0x0001F998 ], // 🦘 
  [ 0x0001F9AC ], // 🦬
  [ 0x0001f403 ], // 🐃 
  [ 0x0001f402 ], // 🐂 
  [ 0x0001f404 ], // 🐄 
  [ 0x0001f40e ], // 🐎 
  [ 0x0001f416 ], // 🐖 
  [ 0x0001f40f ], // 🐏 
  [ 0x0001f411 ], // 🐑 
  [ 0x0001F999 ], // 🦙 
  [ 0x0001f410 ], // 🐐 
  [ 0x0001F98C ], // 🦌 
  [ 0x0001f415 ], // 🐕 
  [ 0x0001f429 ], // 🐩 
  [ 0x0001f9AE ], // 🦮 
  [ 0x0001f415, 0x0000200D, 0x0001F9BA ], // 🐕‍🦺
  [ 0x0001f408 ], // 🐈 
  [ 0x0001F408, 0x0000200D, 0x00002B1B ], // 🐈‍⬛
  [ 0x0001FAB6 ], // 🪶
  [ 0x0001f413 ], // 🐓 
  [ 0x0001f983 ], // 🦃 
  [ 0x0001F9A4 ], // 🦤
  [ 0x0001F99A ], // 🦚 
  [ 0x0001F99C ], // 🦜 
  [ 0x0001F9A2 ], // 🦢 
  [ 0x0001F9A9 ], // 🦩
  [ 0x0001f54a, 0x0000fe0f ], // 🕊️ 
  [ 0x0001f407 ], // 🐇 
  [ 0x0001F99D ], // 🦝 
  [ 0x0001F9A8 ], // 🦨
  [ 0x0001F9A1 ], // 🦡 
  [ 0x0001F9AB ], // 🦫
  [ 0x0001F9A6 ], // 🦦
  [ 0x0001F9A5 ], // 🦥 
  [ 0x0001f401 ], // 🐁 
  [ 0x0001f400 ], // 🐀 
  [ 0x0001f43f, 0x0000fe0f ], // 🐿️ 
  [ 0x0001F994 ], // 🦔 
  [ 0x0001f43e ], // 🐾 
  [ 0x0001f409 ], // 🐉 
  [ 0x0001f432 ], // 🐲 
  [ 0x0001f335 ], // 🌵 
  [ 0x0001f384 ], // 🎄 
  [ 0x0001f332 ], // 🌲 
  [ 0x0001f333 ], // 🌳 
  [ 0x0001f334 ], // 🌴 
  [ 0x0001FAB5 ], // 🪵
  [ 0x0001f331 ], // 🌱 
  [ 0x0001f33f ], // 🌿 
  [ 0x00002618, 0x0000fe0f ], // ☘️ 
  [ 0x0001f340 ], // 🍀 
  [ 0x0001f38d ], // 🎍 
  [ 0x0001FAB4 ], // 🪴
  [ 0x0001f38b ], // 🎋 
  [ 0x0001f343 ], // 🍃 
  [ 0x0001f342 ], // 🍂 
  [ 0x0001f341 ], // 🍁 
  [ 0x0001f344 ], // 🍄 
  [ 0x0001F41A ], // 🐚
  [ 0x0001FAA8 ], // 🪨
  [ 0x0001f33e ], // 🌾 
  [ 0x0001f490 ], // 💐 
  [ 0x0001f337 ], // 🌷 
  [ 0x0001f339 ], // 🌹 
  [ 0x0001F940 ], // 🥀 
  [ 0x0001f33a ], // 🌺 
  [ 0x0001f338 ], // 🌸 
  [ 0x0001f33c ], // 🌼 
  [ 0x0001f33b ], // 🌻 
  [ 0x0001f31e ], // 🌞 
  [ 0x0001f31d ], // 🌝 
  [ 0x0001f31b ], // 🌛 
  [ 0x0001f31c ], // 🌜 
  [ 0x0001f31a ], // 🌚 
  [ 0x0001f315 ], // 🌕 
  [ 0x0001f316 ], // 🌖 
  [ 0x0001f317 ], // 🌗 
  [ 0x0001f318 ], // 🌘 
  [ 0x0001f311 ], // 🌑 
  [ 0x0001f312 ], // 🌒 
  [ 0x0001f313 ], // 🌓 
  [ 0x0001f314 ], // 🌔 
  [ 0x0001f319 ], // 🌙 
  [ 0x0001f30e ], // 🌎 
  [ 0x0001f30d ], // 🌍 
  [ 0x0001f30f ], // 🌏 
  [ 0x0001f4ab ], // 💫 
  [ 0x00002b50 ], // ⭐ 
  [ 0x0001f31f ], // 🌟 
  [ 0x00002728 ], // ✨ 
  [ 0x000026a1 ], // ⚡ 
  [ 0x00002604, 0x0000fe0f ], // ☄️ 
  [ 0x0001f4a5 ], // 💥 
  [ 0x0001f525 ], // 🔥 
  [ 0x0001f32a, 0x0000fe0f ], // 🌪️ 
  [ 0x0001f308 ], // 🌈 
  [ 0x00002600, 0x0000fe0f ], // ☀️ 
  [ 0x0001f324, 0x0000fe0f ], // 🌤️ 
  [ 0x000026c5 ], // ⛅ 
  [ 0x0001f325, 0x0000fe0f ], // 🌥️ 
  [ 0x0001f326, 0x0000fe0f ], // 🌦️ 
  [ 0x00002601, 0x0000fe0f ], // ☁️ 
  [ 0x0001f327, 0x0000fe0f ], // 🌧️ 
  [ 0x000026c8, 0x0000fe0f ], // ⛈️ 
  [ 0x0001f329, 0x0000fe0f ], // 🌩️ 
  [ 0x0001f328, 0x0000fe0f ], // 🌨️ 
  [ 0x00002744, 0x0000fe0f ], // ❄️ 
  [ 0x00002603, 0x0000fe0f ], // ☃️ 
  [ 0x000026c4 ], // ⛄ 
  [ 0x0001f32c, 0x0000fe0f ], // 🌬️ 
  [ 0x0001f4a8 ], // 💨 
  [ 0x0001f4a7 ], // 💧 
  [ 0x0001f4a6 ], // 💦 
  [ 0x00002614 ], // ☔ 
  [ 0x00002602, 0x0000fe0f ], // ☂️ 
  [ 0x0001f30a ], // 🌊 
  [ 0x0001f32b, 0x0000fe0f ] // 🌫️ 
]

export const arrayUnicode3 = [
  [ 0x0001f34f ], // 🍏 
  [ 0x0001f34e ], // 🍎 
  [ 0x0001f350 ], // 🍐 
  [ 0x0001f34a ], // 🍊 
  [ 0x0001f34b ], // 🍋 
  [ 0x0001f34c ], // 🍌 
  [ 0x0001f349 ], // 🍉 
  [ 0x0001f347 ], // 🍇 
  [ 0x0001f353 ], // 🍓
  [ 0x0001FAD0 ], // 🫐
  [ 0x0001f348 ], // 🍈 
  [ 0x0001f352 ], // 🍒 
  [ 0x0001f351 ], // 🍑 
  [ 0x0001F96D ], // 🥭
  [ 0x0001f34d ], // 🍍 
  [ 0x0001F965 ], // 🥥 
  [ 0x0001F95D ], // 🥝 
  [ 0x0001f345 ], // 🍅 
  [ 0x0001f346 ], // 🍆 
  [ 0x0001F951 ], // 🥑 
  [ 0x0001F966 ], // 🥦 
  [ 0x0001F952 ], // 🥒 
  [ 0x0001f336, 0x0000fe0f ], // 🌶️ 
  [ 0x0001FAD1 ], // 🫑
  [ 0x0001f33d ], // 🌽 
  [ 0x0001F955 ], // 🥕 
  [ 0x0001FAD2 ], // 🫒
  [ 0x0001F9C4 ], // 🧄
  [ 0x0001F9C5 ], // 🧅
  [ 0x0001F954 ], // 🥔 
  [ 0x0001f360 ], // 🍠 
  [ 0x0001F950 ], // 🥐 
  [ 0x0001F96F ], // 🥯
  [ 0x0001f35e ], // 🍞 
  [ 0x0001F956 ], // 🥖 
  [ 0x0001F968 ], // 🥨 
  [ 0x0001f9c0 ], // 🧀 
  [ 0x0001F95A ], // 🥚 
  [ 0x0001f373 ], // 🍳 
  [ 0x0001f9C8 ], // 🧈
  [ 0x0001F95E ], // 🥞 
  [ 0x0001F9C7 ], // 🧇
  [ 0x0001F953 ], // 🥓 
  [ 0x0001F969 ], // 🥩 
  [ 0x0001f357 ], // 🍗 
  [ 0x0001f356 ], // 🍖 
  [ 0x0001f9B4 ], // 🦴
  [ 0x0001f32d ], // 🌭 
  [ 0x0001f354 ], // 🍔 
  [ 0x0001f35f ], // 🍟 
  [ 0x0001f355 ], // 🍕 
  [ 0x0001FAD3 ], // 🥯
  [ 0x0001F96A ], // 🥪 
  [ 0x0001F959 ], // 🥙 
  [ 0x0001F9C6 ], // 🧆
  [ 0x0001f32e ], // 🌮 
  [ 0x0001f32f ], // 🌯 
  [ 0x0001FAD4 ], // 🫔
  [ 0x0001F957 ], // 🥗 
  [ 0x0001F958 ], // 🥘 
  [ 0x0001FAD5 ], // 🫕
  [ 0x0001F96B ], // 🥫 
  [ 0x0001f35d ], // 🍝 
  [ 0x0001f35c ], // 🍜 
  [ 0x0001f372 ], // 🍲 
  [ 0x0001f35b ], // 🍛 
  [ 0x0001f363 ], // 🍣 
  [ 0x0001f371 ], // 🍱 
  [ 0x0001F95F ], // 🥟 
  [ 0x0001F9AA ], // 🦪
  [ 0x0001f364 ], // 🍤 
  [ 0x0001f359 ], // 🍙 
  [ 0x0001f35a ], // 🍚 
  [ 0x0001f358 ], // 🍘 
  [ 0x0001f365 ], // 🍥 
  [ 0x0001F960 ], // 🥠 
  [ 0x0001F96E ], // 🥮
  [ 0x0001f362 ], // 🍢 
  [ 0x0001f361 ], // 🍡 
  [ 0x0001f367 ], // 🍧 
  [ 0x0001f368 ], // 🍨 
  [ 0x0001f366 ], // 🍦 
  [ 0x0001F967 ], // 🥧
  [ 0x0001F9C1 ], // 🧁
  [ 0x0001f370 ], // 🍰 
  [ 0x0001f382 ], // 🎂 
  [ 0x0001f36e ], // 🍮 
  [ 0x0001f36d ], // 🍭 
  [ 0x0001f36c ], // 🍬 
  [ 0x0001f36b ], // 🍫 
  [ 0x0001f37f ], // 🍿 
  [ 0x0001f369 ], // 🍩 
  [ 0x0001f36a ], // 🍪 
  [ 0x0001f330 ], // 🌰 
  [ 0x0001F95C ], // 🥜 
  [ 0x0001f36f ], // 🍯 
  [ 0x0001F95B ], // 🥛 
  [ 0x0001f37c ], // 🍼 
  [ 0x0001FAD6 ], // 🫖
  [ 0x00002615 ], // ☕ 
  [ 0x0001f375 ], // 🍵 
  [ 0x0001f9C3 ], // 🧃
  [ 0x0001F964 ], // 🥤 
  [ 0x0001F9CB ], // 🧋
  [ 0x0001f376 ], // 🍶 
  [ 0x0001f37a ], // 🍺 
  [ 0x0001f37b ], // 🍻 
  [ 0x0001F942 ], // 🥂 
  [ 0x0001f377 ], // 🍷 
  [ 0x0001F943 ], // 🥃 
  [ 0x0001f378 ], // 🍸 
  [ 0x0001f379 ], // 🍹 
  [ 0x0001F9C9 ], // 🧉
  [ 0x0001f37e ], // 🍾 
  [ 0x0001F9CA ], // 🧊
  [ 0x0001F944 ], // 🥄 
  [ 0x0001f374 ], // 🍴 
  [ 0x0001f37d, 0x0000fe0f ], // 🍽️ 
  [ 0x0001F963 ], // 🥣 
  [ 0x0001F961 ], // 🥡 
  [ 0x0001F962 ], // 🥢 
  [ 0x0001F9C2 ] // 🧂
]

export const arrayUnicode4 = [
  [ 0x000026bd ], // ⚽ 
  [ 0x0001f3c0 ], // 🏀 
  [ 0x0001f3c8 ], // 🏈 
  [ 0x000026be ], // ⚾ 
  [ 0x0001F94E ], // 🥎 
  [ 0x0001f3be ], // 🎾 
  [ 0x0001f3d0 ], // 🏐 
  [ 0x0001f3c9 ], // 🏉 
  [ 0x0001F94F ], // 🥏 
  [ 0x0001f3b1 ], // 🎱 
  [ 0x0001FA80 ], // 🪀
  [ 0x0001f3d3 ], // 🏓 
  [ 0x0001f3f8 ], // 🏸 
  [ 0x0001f3d2 ], // 🏒 
  [ 0x0001f3d1 ], // 🏑 
  [ 0x0001F94D ], // 🥍 
  [ 0x0001f3cf ], // 🏏 
  [ 0x0001FA83 ], // 🪃
  [ 0x0001F945 ], // 🥅 
  [ 0x000026f3 ], // ⛳ 
  [ 0x0001FA81 ], // 🪁
  [ 0x0001f3f9 ], // 🏹 
  [ 0x0001f3a3 ], // 🎣 
  [ 0x0001F93F ], // 🤿
  [ 0x0001F94A ], // 🥊 
  [ 0x0001F94B ], // 🥋 
  [ 0x0001f3bd ], // 🎽 
  [ 0x0001F6F9 ], // 🛹
  [ 0x0001F6FC ], // 🛼
  [ 0x0001F6F7 ], // 🛷 
  [ 0x000026f8, 0x0000fe0f ], // ⛸️ 
  [ 0x0001F94C ], // 🥌 
  [ 0x0001f3bf ], // 🎿 
  [ 0x000026f7, 0x0000fe0f ], // ⛷️ 
  [ 0x0001f3c2 ], // 🏂 
  [ 0x0001fA82 ], // 🪂
  [ 0x0001f3cb, 0x0000fe0f, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🏋️‍♀️ 
  [ 0x0001f3cb ], // 🏋
  [ 0x0001f3cb, 0x0000fe0f, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🏋️‍♂️ 
  [ 0x0001F93C, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🤼‍♀️ 
  [ 0x0001F93C ], // 🤼
  [ 0x0001F93C, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🤼‍♂️ 
  [ 0x0001F938, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🤸‍♀️ 
  [ 0x0001F938 ], // 🤸 
  [ 0x0001F938, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🤸‍♂️ 
  [ 0x000026f9, 0x0000fe0f, 0x0000200d, 0x00002640, 0x0000fe0f ], // ⛹️‍♀️ 
  [ 0x000026f9 ], // ⛹ 
  [ 0x000026f9, 0x0000fe0f, 0x0000200d, 0x00002642, 0x0000fe0f ], // ⛹️ 
  [ 0x0001F93A ], // 🤺 
  [ 0x0001F93E, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🤾‍♀️
  [ 0x0001F93E ], // 🤾 
  [ 0x0001F93E, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🤾‍♂️ 
  [ 0x0001f3cc, 0x0000fe0f, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🏌️‍♀️ 
  [ 0x0001f3cc ], // 🏌
  [ 0x0001f3cc, 0x0000fe0f, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🏌️‍♂️ 
  [ 0x0001f3c7 ], // 🏇 
  [ 0x0001F9D8, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧘‍♀️
  [ 0x0001F9D8 ], // 🧘 
  [ 0x0001F9D8, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧘‍♂️ 
  [ 0x0001f3c4, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🏄‍♀️ 
  [ 0x0001f3c4 ], // 🏄 
  [ 0x0001f3c4, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🏄‍♂️
  [ 0x0001f3ca, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🏊‍♀️ 
  [ 0x0001f3ca ], // 🏊
  [ 0x0001f3ca, 0x0000200d, 0x00002642, 0x0000fe0f ], //🏊‍♂️
  [ 0x0001F93D, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🤽‍♀️ 
  [ 0x0001f93D ], // 🤽 
  [ 0x0001f93d, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🤽‍♂️
  [ 0x0001f6a3, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🚣‍♀️ 
  [ 0x0001f6a3 ], // 🚣 
  [ 0x0001f6a3, 0x0000200d, 0x00002642, 0x0000fe0f ], //🚣‍♂️	
  [ 0x0001F9D7, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🧗‍♀️
  [ 0x0001F9D7 ], // 🧗 
  [ 0x0001F9D7, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🧗‍♂️ 
  [ 0x0001f6b5, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🚵‍♀️ 
  [ 0x0001f6b5 ], // 🚵 
  [ 0x0001f6b5, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🚵‍♂️
  [ 0x0001f6b4, 0x0000200d, 0x00002640, 0x0000fe0f ], // 🚴‍♀️ 
  [ 0x0001f6b4 ], // 🚴 
  [ 0x0001f6b4, 0x0000200d, 0x00002642, 0x0000fe0f ], // 🚴‍♂️
  [ 0x0001f3c6 ], // 🏆 
  [ 0x0001f947 ], // 🥇 
  [ 0x0001f948 ], // 🥈 
  [ 0x0001f949 ], // 🥉 
  [ 0x0001f3c5 ], // 🏅 
  [ 0x0001f396, 0x0000fe0f ], // 🎖️ 
  [ 0x0001f3f5, 0x0000fe0f ], // 🏵️ 
  [ 0x0001f397, 0x0000fe0f ], // 🎗️ 
  [ 0x0001f3ab ], // 🎫 
  [ 0x0001f39f, 0x0000fe0f ], // 🎟️ 
  [ 0x0001f3aa ], // 🎪 
  [ 0x0001F939, 0x0000200D, 0x00002640, 0x0000FE0F ], // 🤹‍♀️ 
  [ 0x0001F939 ], // 🤹 
  [ 0x0001F939, 0x0000200D, 0x00002642, 0x0000FE0F ], // 🤹‍♂️
  [ 0x0001f3ad ], // 🎭 
  [ 0x0001fa70 ], // 🩰
  [ 0x0001f3a8 ], // 🎨 
  [ 0x0001f3ac ], // 🎬 
  [ 0x0001f3a4 ], // 🎤 
  [ 0x0001f3a7 ], // 🎧 
  [ 0x0001f3bc ], // 🎼 
  [ 0x0001f3b9 ], // 🎹 
  [ 0x0001F941 ], // 🥁 
  [ 0x0001FA98 ], // 🪘
  [ 0x0001f3b7 ], // 🎷 
  [ 0x0001f3ba ], // 🎺 
  [ 0x0001FA97 ], // 🪗
  [ 0x0001f3b8 ], // 🎸 
  [ 0x0001fa95 ], // 🪕
  [ 0x0001f3bb ], // 🎻 
  [ 0x0001f3b2 ], // 🎲 
  [ 0x0000265F, 0x0000fe0f ], // ♟ 
  [ 0x0001f3af ], // 🎯 
  [ 0x0001f3b3 ], // 🎳 
  [ 0x0001f3ae ], // 🎮 
  [ 0x0001f3b0 ], // 🎰 
  [ 0x0001F9E9 ] // 🧩 
]

export const arrayUnicode5 = [
  [ 0x0001f697 ], // 🚗 
  [ 0x0001f695 ], // 🚕 
  [ 0x0001f699 ], // 🚙 
  [ 0x0001f68c ], // 🚌 
  [ 0x0001f68e ], // 🚎 
  [ 0x0001f3ce, 0x0000FE0F ], // 🏎️ 
  [ 0x0001f693 ], // 🚓 
  [ 0x0001f691 ], // 🚑 
  [ 0x0001f692 ], // 🚒 
  [ 0x0001f690 ], // 🚐 
  [ 0x0001F6FB ], // 🛻
  [ 0x0001f69a ], // 🚚 
  [ 0x0001f69b ], // 🚛 
  [ 0x0001f69c ], // 🚜 
  [ 0x0001f9af ], // 🦯
  [ 0x0001f9bd ], // 🦽
  [ 0x0001f9bc ], // 🦼
  [ 0x0001F6F4 ], // 🛴 
  [ 0x0001f6b2 ], // 🚲 
  [ 0x0001F6F5 ], // 🛵 
  [ 0x0001f3cd, 0x0000FE0F ], // 🏍️ 
  [ 0x0001f6fa ], // 🛺
  [ 0x0001f6a8 ], // 🚨 
  [ 0x0001f694 ], // 🚔 
  [ 0x0001f68d ], // 🚍 
  [ 0x0001f698 ], // 🚘 
  [ 0x0001f696 ], // 🚖 
  [ 0x0001f6a1 ], // 🚡 
  [ 0x0001f6a0 ], // 🚠 
  [ 0x0001f69f ], // 🚟 
  [ 0x0001f683 ], // 🚃 
  [ 0x0001f68b ], // 🚋 
  [ 0x0001f69e ], // 🚞 
  [ 0x0001f69d ], // 🚝 
  [ 0x0001f684 ], // 🚄 
  [ 0x0001f685 ], // 🚅 
  [ 0x0001f688 ], // 🚈 
  [ 0x0001f682 ], // 🚂 
  [ 0x0001f686 ], // 🚆 
  [ 0x0001f687 ], // 🚇 
  [ 0x0001f68a ], // 🚊 
  [ 0x0001f689 ], // 🚉 
  [ 0x00002708, 0x0000fe0f ], // ✈️ 
  [ 0x0001f6eb ], // 🛫 
  [ 0x0001f6ec ], // 🛬 
  [ 0x0001f6e9, 0x0000fe0f ], // 🛩️ 
  [ 0x0001f4ba ], // 💺 
  [ 0x0001f6f0, 0x0000fe0f ], // 🛰️ 
  [ 0x0001f680 ], // 🚀 
  [ 0x0001F6F8 ], // 🛸 
  [ 0x0001f681 ], // 🚁 
  [ 0x0001F6F6 ], // 🛶 
  [ 0x000026f5 ], // ⛵ 
  [ 0x0001f6a4 ], // 🚤 
  [ 0x0001f6e5, 0x0000fe0f ], // 🛥️ 
  [ 0x0001f6f3, 0x0000fe0f ], // 🛳️ 
  [ 0x000026f4, 0x0000fe0f ], // ⛴️ 
  [ 0x0001f6a2 ], // 🚢 
  [ 0x00002693 ], // ⚓ 
  [ 0x0001FA9D ], // 🪝
  [ 0x000026fd ], // ⛽ 
  [ 0x0001f6a7 ], // 🚧 
  [ 0x0001f6a6 ], // 🚦 
  [ 0x0001f6a5 ], // 🚥 
  [ 0x0001f68f ], // 🚏 
  [ 0x0001f5fa, 0x0000fe0f ], // 🗺️ 
  [ 0x0001f5ff ], // 🗿 
  [ 0x0001f5fd ], // 🗽 
  [ 0x0001f5fc ], // 🗼 
  [ 0x0001f3f0 ], // 🏰 
  [ 0x0001f3ef ], // 🏯 
  [ 0x0001f3df, 0x0000fe0f ], // 🏟️ 
  [ 0x0001f3a1 ], // 🎡 
  [ 0x0001f3a2 ], // 🎢 
  [ 0x0001f3a0 ], // 🎠 
  [ 0x000026f2 ], // ⛲ 
  [ 0x000026f1, 0x0000fe0f ], // ⛱️ 
  [ 0x0001f3d6, 0x0000fe0f ], // 🏖️ 
  [ 0x0001f3dd, 0x0000fe0f ], // 🏝️ 
  [ 0x0001f3dc, 0x0000fe0f ], // 🏜️ 
  [ 0x0001f30b ], // 🌋 
  [ 0x000026f0, 0x0000fe0f ], // ⛰️ 
  [ 0x0001f3d4, 0x0000fe0f ], // 🏔️ 
  [ 0x0001f5fb ], // 🗻 
  [ 0x0001f3d5, 0x0000fe0f ], // 🏕️ 
  [ 0x000026fa ], // ⛺ 
  [ 0x0001F6D6 ], // 🛖
  [ 0x0001f3e0 ], // 🏠 
  [ 0x0001f3e1 ], // 🏡 
  [ 0x0001f3d8, 0x0000fe0f ], // 🏘️ 
  [ 0x0001f3da, 0x0000fe0f ], // 🏚️ 
  [ 0x0001f3d7, 0x0000fe0f ], // 🏗️ 
  [ 0x0001f3ed ], // 🏭 
  [ 0x0001f3e2 ], // 🏢 
  [ 0x0001f3ec ], // 🏬 
  [ 0x0001f3e3 ], // 🏣 
  [ 0x0001f3e4 ], // 🏤 
  [ 0x0001f3e5 ], // 🏥 
  [ 0x0001f3e6 ], // 🏦 
  [ 0x0001f3e8 ], // 🏨 
  [ 0x0001f3ea ], // 🏪 
  [ 0x0001f3eb ], // 🏫 
  [ 0x0001f3e9 ], // 🏩 
  [ 0x0001f492 ], // 💒 
  [ 0x0001f3db, 0x0000fe0f ], // 🏛️ 
  [ 0x000026ea ], // ⛪ 
  [ 0x0001f54c ], // 🕌 
  [ 0x0001f54d ], // 🕍 
  [ 0x0001f6d5 ], // 🛕
  [ 0x0001f54b ], // 🕋 
  [ 0x000026e9, 0x0000fe0f ], // ⛩️ 
  [ 0x0001f6e4, 0x0000fe0f ], // 🛤️ 
  [ 0x0001f6e3, 0x0000fe0f ], // 🛣️ 
  [ 0x0001f5fe ], // 🗾 
  [ 0x0001f391 ], // 🎑 
  [ 0x0001f3de, 0x0000fe0f ], // 🏞️ 
  [ 0x0001f305 ], // 🌅 
  [ 0x0001f304 ], // 🌄 
  [ 0x0001f320 ], // 🌠 
  [ 0x0001f387 ], // 🎇 
  [ 0x0001f386 ], // 🎆 
  [ 0x0001f307 ], // 🌇 
  [ 0x0001f306 ], // 🌆 
  [ 0x0001f3d9, 0x0000fe0f ], // 🏙️ 
  [ 0x0001f303 ], // 🌃 
  [ 0x0001f30c ], // 🌌 
  [ 0x0001f309 ], // 🌉 
  [ 0x0001f301 ] // 🌁 
]

export const arrayUnicode6 = [
  [ 0x0000231a ], // ⌚ 
  [ 0x0001f4f1 ], // 📱 
  [ 0x0001f4f2 ], // 📲 
  [ 0x0001f4bb ], // 💻 
  [ 0x00002328, 0x0000fe0f ], // ⌨️ 
  [ 0x0001f5a5, 0x0000fe0f ], // 🖥️ 
  [ 0x0001f5a8, 0x0000fe0f ], // 🖨️ 
  [ 0x0001f5b1, 0x0000fe0f ], // 🖱️ 
  [ 0x0001f5b2, 0x0000fe0f ], // 🖲️ 
  [ 0x0001f579, 0x0000fe0f ], // 🕹️ 
  [ 0x0001f5dc, 0x0000fe0f ], // 🗜️ 
  [ 0x0001f4bd ], // 💽 
  [ 0x0001f4be ], // 💾 
  [ 0x0001f4bf ], // 💿 
  [ 0x0001f4c0 ], // 📀 
  [ 0x0001f4fc ], // 📼 
  [ 0x0001f4f7 ], // 📷 
  [ 0x0001f4f8 ], // 📸 
  [ 0x0001f4f9 ], // 📹 
  [ 0x0001f3a5 ], // 🎥 
  [ 0x0001f4fd, 0x0000fe0f ], // 📽️ 
  [ 0x0001f39e, 0x0000fe0f ], // 🎞️ 
  [ 0x0001f4de ], // 📞 
  [ 0x0000260e, 0x0000fe0f ], // ☎️ 
  [ 0x0001f4df ], // 📟 
  [ 0x0001f4e0 ], // 📠 
  [ 0x0001f4fa ], // 📺 
  [ 0x0001f4fb ], // 📻 
  [ 0x0001f399, 0x0000fe0f ], // 🎙️ 
  [ 0x0001f39a, 0x0000fe0f ], // 🎚️ 
  [ 0x0001f39b, 0x0000fe0f ], // 🎛️ 
  [ 0x0001F9ED ], // 🧭
  [ 0x000023f1, 0x0000fe0f ], // ⏱️ 
  [ 0x000023f2, 0x0000fe0f ], // ⏲️ 
  [ 0x000023f0 ], // ⏰ 
  [ 0x0001f570, 0x0000fe0f ], // 🕰️ 
  [ 0x0000231b ], // ⌛ 
  [ 0x000023f3 ], // ⏳ 
  [ 0x0001f4e1 ], // 📡 
  [ 0x0001f50b ], // 🔋 
  [ 0x0001f50c ], // 🔌 
  [ 0x0001f4a1 ], // 💡 
  [ 0x0001f526 ], // 🔦 
  [ 0x0001f56f, 0x0000fe0f ], // 🕯️ 
  [ 0x0001FA94 ], // 🪔
  [ 0x0001F9EF ], // 🧯 
  [ 0x0001f6e2, 0x0000fe0f ], // 🛢️ 
  [ 0x0001f4b8 ], // 💸 
  [ 0x0001f4b5 ], // 💵 
  [ 0x0001f4b4 ], // 💴 
  [ 0x0001f4b6 ], // 💶 
  [ 0x0001f4b7 ], // 💷 
  [ 0x0001FA99 ], // 🪙
  [ 0x0001f4b0 ], // 💰 
  [ 0x0001f4b3 ], // 💳 
  [ 0x0001f48e ], // 💎 
  [ 0x00002696, 0x0000fe0f ], // ⚖️ 
  [ 0x0001FA9C ], // 🪜
  [ 0x0001F9F0 ], // 🧰 
  [ 0x0001FA9B ], // 🪛
  [ 0x0001f527 ], // 🔧 
  [ 0x0001f528 ], // 🔨 
  [ 0x00002692, 0x0000fe0f ], // ⚒️ 
  [ 0x0001f6e0, 0x0000fe0f ], // 🛠️ 
  [ 0x000026cf, 0x0000fe0f ], // ⛏️ 
  [ 0x0001FA9A ], // 🪚
  [ 0x0001f529 ], // 🔩 
  [ 0x00002699, 0x0000fe0f ], // ⚙️ 
  [ 0x0001FAA4 ], // 🪤
  [ 0x0001f9f1 ], // 🧱
  [ 0x000026d3, 0x0000fe0f ], // ⛓️ 
  [ 0x0001F9F2 ], // 🧲 
  [ 0x0001f52b ], // 🔫 
  [ 0x0001f4a3 ], // 💣 
  [ 0x0001F9E8 ], // 🧨 
  [ 0x0001Fa93 ], // 🪓
  [ 0x0001f52a ], // 🔪 
  [ 0x0001f5e1, 0x0000fe0f ], // 🗡️ 
  [ 0x00002694, 0x0000fe0f ], // ⚔️ 
  [ 0x0001f6e1, 0x0000fe0f ], // 🛡️ 
  [ 0x0001f6ac ], // 🚬 
  [ 0x000026b0, 0x0000fe0f ], // ⚰️ 
  [ 0x0001FAA6 ], // 🪦
  [ 0x000026b1, 0x0000fe0f ], // ⚱️ 
  [ 0x0001f3fa ], // 🏺 
  [ 0x0001f52e ], // 🔮 
  [ 0x0001f4ff ], // 📿 
  [ 0x0001F9FF ], // 🧿 
  [ 0x0001f488 ], // 💈 
  [ 0x00002697, 0x0000fe0f ], // ⚗️ 
  [ 0x0001f52d ], // 🔭 
  [ 0x0001f52c ], // 🔬 
  [ 0x0001f573, 0x0000fe0f ], // 🕳️ 
  [ 0x0001FA79 ], // 🩹
  [ 0x0001fa7a ], // 🩺
  [ 0x0001f48a ], // 💊 
  [ 0x0001f489 ], // 💉 
  [ 0x0001fa78 ], // 🩸
  [ 0x0001F9EC ], // 🧬 
  [ 0x0001F9A0 ], // 🦠 
  [ 0x0001F9EB ], // 🧫 
  [ 0x0001F9EA ], // 🧪 
  [ 0x0001f321, 0x0000fe0f ], // 🌡️ 
  [ 0x0001F9F9 ], // 🧹 
  [ 0x0001FAA0 ], // 🪠
  [ 0x0001F9FA ], // 🧺 
  [ 0x0001F9FB ], // 🧻 
  [ 0x0001f6bd ], // 🚽 
  [ 0x0001f6b0 ], // 🚰 
  [ 0x0001f6bf ], // 🚿 
  [ 0x0001f6c1 ], // 🛁 
  [ 0x0001f6c0 ], // 🛀 
  [ 0x0001F9FC ], // 🧼 
  [ 0x0001FAA5 ], // 🪥
  [ 0x0001Fa92 ], // 🪒
  [ 0x0001F9FD ], // 🧽 
  [ 0x0001FAA3 ], // 🪣
  [ 0x0001F9F4 ], // 🧴 
  [ 0x0001f6ce, 0x0000fe0f ], // 🛎️ 
  [ 0x0001f511 ], // 🔑 
  [ 0x0001f5dd, 0x0000fe0f ], // 🗝️ 
  [ 0x0001f6aa ], // 🚪 
  [ 0x0001fa91 ], // 🪑
  [ 0x0001f6cb, 0x0000fe0f ], // 🛋️ 
  [ 0x0001f6cf, 0x0000fe0f ], // 🛏️ 
  [ 0x0001f6cc ], // 🛌 
  [ 0x0001F9F8 ], // 🧸 
  [ 0x0001FA86 ], // 🪆
  [ 0x0001f5bc, 0x0000fe0f ], // 🖼️ 
  [ 0x0001FA9E ], // 🪞
  [ 0x0001FA9F ], // 🪟
  [ 0x0001f6cd, 0x0000fe0f ], // 🛍️ 
  [ 0x0001F6D2 ], // 🛒 
  [ 0x0001f381 ], // 🎁 
  [ 0x0001f388 ], // 🎈 
  [ 0x0001f38f ], // 🎏 
  [ 0x0001f380 ], // 🎀 
  [ 0x0001FA84 ], // 🪄
  [ 0x0001FA85 ], // 🪅
  [ 0x0001f38a ], // 🎊 
  [ 0x0001f389 ], // 🎉 
  [ 0x0001f38e ], // 🎎 
  [ 0x0001f3ee ], // 🏮 
  [ 0x0001f390 ], // 🎐 
  [ 0x0001F9E7 ], // 🧧 
  [ 0x00002709, 0x0000fe0f ], // ✉️ 
  [ 0x0001f4e9 ], // 📩 
  [ 0x0001f4e8 ], // 📨 
  [ 0x0001f4e7 ], // 📧 
  [ 0x0001f48c ], // 💌 
  [ 0x0001f4e5 ], // 📥 
  [ 0x0001f4e4 ], // 📤 
  [ 0x0001f4e6 ], // 📦 
  [ 0x0001f3f7, 0x0000fe0f ], // 🏷️ 
  [ 0x0001FAA7 ], // 🪧
  [ 0x0001f4ea ], // 📪 
  [ 0x0001f4eb ], // 📫 
  [ 0x0001f4ec ], // 📬 
  [ 0x0001f4ed ], // 📭 
  [ 0x0001f4ee ], // 📮 
  [ 0x0001f4ef ], // 📯 
  [ 0x0001f4dc ], // 📜 
  [ 0x0001f4c3 ], // 📃 
  [ 0x0001f4c4 ], // 📄 
  [ 0x0001f4d1 ], // 📑 
  [ 0x0001F9FE ], // 🧾 
  [ 0x0001f4ca ], // 📊 
  [ 0x0001f4c8 ], // 📈 
  [ 0x0001f4c9 ], // 📉 
  [ 0x0001f5d2, 0x0000fe0f ], // 🗒️ 
  [ 0x0001f5d3, 0x0000fe0f ], // 🗓️ 
  [ 0x0001f4c6 ], // 📆 
  [ 0x0001f4c5 ], // 📅 
  [ 0x0001f5d1, 0x0000fe0f ], // 🗑️ 
  [ 0x0001f4c7 ], // 📇 
  [ 0x0001f5c3, 0x0000fe0f ], // 🗃️ 
  [ 0x0001f5f3, 0x0000fe0f ], // 🗳️ 
  [ 0x0001f5c4, 0x0000fe0f ], // 🗄️ 
  [ 0x0001f4cb ], // 📋 
  [ 0x0001f4c1 ], // 📁 
  [ 0x0001f4c2 ], // 📂 
  [ 0x0001f5c2, 0x0000fe0f ], // 🗂️ 
  [ 0x0001f5de, 0x0000fe0f ], // 🗞️ 
  [ 0x0001f4f0 ], // 📰 
  [ 0x0001f4d3 ], // 📓 
  [ 0x0001f4d4 ], // 📔 
  [ 0x0001f4d2 ], // 📒 
  [ 0x0001f4d5 ], // 📕 
  [ 0x0001f4d7 ], // 📗 
  [ 0x0001f4d8 ], // 📘 
  [ 0x0001f4d9 ], // 📙 
  [ 0x0001f4da ], // 📚 
  [ 0x0001f4d6 ], // 📖 
  [ 0x0001f516 ], // 🔖 
  [ 0x0001F9F7 ], // 🧷 
  [ 0x0001f517 ], // 🔗 
  [ 0x0001f4ce ], // 📎 
  [ 0x0001f587, 0x0000fe0f ], // 🖇️ 
  [ 0x0001f4d0 ], // 📐 
  [ 0x0001f4cf ], // 📏 
  [ 0x0001F9EE ], // 🧮 
  [ 0x0001f4cc ], // 📌 
  [ 0x0001f4cd ], // 📍 
  [ 0x00002702, 0x0000fe0f ], // ✂️ 
  [ 0x0001f58a, 0x0000fe0f ], // 🖊️ 
  [ 0x0001f58b, 0x0000fe0f ], // 🖋️ 
  [ 0x00002712, 0x0000fe0f ], // ✒️ 
  [ 0x0001f58c, 0x0000fe0f ], // 🖌️ 
  [ 0x0001f58d, 0x0000fe0f ], // 🖍️ 
  [ 0x0001f4dd ], // 📝 
  [ 0x0000270f, 0x0000fe0f ], // ✏️ 
  [ 0x0001f50d ], // 🔍 
  [ 0x0001f50e ], // 🔎 
  [ 0x0001f50f ], // 🔏 
  [ 0x0001f510 ], // 🔐 
  [ 0x0001f512 ], // 🔒 
  [ 0x0001f513 ] // 🔓 
]

export const arrayUnicode7 = [
  [ 0x00002764, 0x0000fe0f ], // ❤️ 
  [ 0x0001F9E1 ], // 🧡
  [ 0x0001f49b ], // 💛 
  [ 0x0001f49a ], // 💚 
  [ 0x0001f499 ], // 💙 
  [ 0x0001f49c ], // 💜 
  [ 0x0001F5A4 ], // 🖤
  [ 0x0001F90D ], // 🤍
  [ 0x0001F90E ], // 🤎
  [ 0x0001f494 ], // 💔 
  [ 0x00002763, 0x0000fe0f ], // ❣️ 
  [ 0x0001f495 ], // 💕 
  [ 0x0001f49e ], // 💞 
  [ 0x0001f493 ], // 💓 
  [ 0x0001f497 ], // 💗 
  [ 0x0001f496 ], // 💖 
  [ 0x0001f498 ], // 💘 
  [ 0x0001f49d ], // 💝 
  [ 0x0001f49f ], // 💟 
  [ 0x0000262e, 0x0000fe0f ], // ☮️ 
  [ 0x0000271d, 0x0000fe0f ], // ✝️ 
  [ 0x0000262a, 0x0000fe0f ], // ☪️ 
  [ 0x0001f549, 0x0000fe0f ], // 🕉️ 
  [ 0x00002638, 0x0000fe0f ], // ☸️ 
  [ 0x00002721, 0x0000fe0f ], // ✡️ 
  [ 0x0001f52f ], // 🔯 
  [ 0x0001f54e ], // 🕎 
  [ 0x0000262f, 0x0000fe0f ], // ☯️ 
  [ 0x00002626, 0x0000fe0f ], // ☦️ 
  [ 0x0001f6d0 ], // 🛐 
  [ 0x000026ce ], // ⛎ 
  [ 0x00002648 ], // ♈ 
  [ 0x00002649 ], // ♉ 
  [ 0x0000264a ], // ♊ 
  [ 0x0000264b ], // ♋ 
  [ 0x0000264c ], // ♌ 
  [ 0x0000264d ], // ♍ 
  [ 0x0000264e ], // ♎ 
  [ 0x0000264f ], // ♏ 
  [ 0x00002650 ], // ♐ 
  [ 0x00002651 ], // ♑ 
  [ 0x00002652 ], // ♒ 
  [ 0x00002653 ], // ♓ 
  [ 0x0001f194 ], // 🆔 
  [ 0x0000269b, 0x0000fe0f ], // ⚛️ 
  [ 0x0001f251 ], // 🉑 
  [ 0x00002622, 0x0000fe0f ], // ☢️ 
  [ 0x00002623, 0x0000fe0f ], // ☣️ 
  [ 0x0001f4f4 ], // 📴 
  [ 0x0001f4f3 ], // 📳 
  [ 0x0001f236 ], // 🈶 
  [ 0x0001f21a ], // 🈚 
  [ 0x0001f238 ], // 🈸 
  [ 0x0001f23a ], // 🈺 
  [ 0x0001f237, 0x0000fe0f ], // 🈷️ 
  [ 0x00002734, 0x0000fe0f ], // ✴️ 
  [ 0x0001f19a ], // 🆚 
  [ 0x0001f4ae ], // 💮 
  [ 0x0001f250 ], // 🉐 
  [ 0x00003299, 0x0000fe0f ], // ㊙️ 
  [ 0x00003297, 0x0000fe0f ], // ㊗️ 
  [ 0x0001f234 ], // 🈴 
  [ 0x0001f235 ], // 🈵 
  [ 0x0001f239 ], // 🈹 
  [ 0x0001f232 ], // 🈲 
  [ 0x0001f170, 0x0000fe0f ], // 🅰️ 
  [ 0x0001f171, 0x0000fe0f ], // 🅱️ 
  [ 0x0001f18e ], // 🆎 
  [ 0x0001f191 ], // 🆑 
  [ 0x0001f17e, 0x0000fe0f ], // 🅾️ 
  [ 0x0001f198 ], // 🆘 
  [ 0x0000274c ], // ❌ 
  [ 0x00002b55 ], // ⭕ 
  [ 0x0001F6D1 ], // 🛑 
  [ 0x000026d4 ], // ⛔ 
  [ 0x0001f4db ], // 📛 
  [ 0x0001f6ab ], // 🚫 
  [ 0x0001f4af ], // 💯 
  [ 0x0001f4a2 ], // 💢 
  [ 0x00002668, 0x0000fe0f ], // ♨️ 
  [ 0x0001f6b7 ], // 🚷 
  [ 0x0001f6af ], // 🚯 
  [ 0x0001f6b3 ], // 🚳 
  [ 0x0001f6b1 ], // 🚱 
  [ 0x0001f51e ], // 🔞 
  [ 0x0001f4f5 ], // 📵 
  [ 0x0001f6ad ], // 🚭 
  [ 0x00002757 ], // ❗ 
  [ 0x00002755 ], // ❕ 
  [ 0x00002753 ], // ❓ 
  [ 0x00002754 ], // ❔ 
  [ 0x0000203c, 0x0000fe0f ], // ‼️ 
  [ 0x00002049, 0x0000fe0f ], // ⁉️ 
  [ 0x0001f505 ], // 🔅 
  [ 0x0001f506 ], // 🔆 
  [ 0x0000303d, 0x0000fe0f ], // 〽️ 
  [ 0x000026a0, 0x0000fe0f ], // ⚠️ 
  [ 0x0001f6b8 ], // 🚸 
  [ 0x0001f531 ], // 🔱 
  [ 0x0000269c, 0x0000fe0f ], // ⚜️ 
  [ 0x0001f530 ], // 🔰 
  [ 0x0000267b, 0x0000fe0f ], // ♻️ 
  [ 0x00002705 ], // ✅ 
  [ 0x0001f22f ], // 🈯 
  [ 0x0001f4b9 ], // 💹 
  [ 0x00002747, 0x0000fe0f ], // ❇️ 
  [ 0x00002733, 0x0000fe0f ], // ✳️ 
  [ 0x0000274e ], // ❎ 
  [ 0x0001f310 ], // 🌐 
  [ 0x0001f4a0 ], // 💠 
  [ 0x000024c2, 0x0000fe0f ], // Ⓜ️ 
  [ 0x0001f300 ], // 🌀 
  [ 0x0001f4a4 ], // 💤 
  [ 0x000027bf ], // ➿ 
  [ 0x0001f3e7 ], // 🏧 
  [ 0x0001f6be ], // 🚾 
  [ 0x0000267f ], // ♿ 
  [ 0x0001f17f, 0x0000fe0f ], // 🅿️ 
  [ 0x0001f233 ], // 🈳 
  [ 0x0001f202, 0x0000fe0f ], // 🈂️ 
  [ 0x0001f6c2 ], // 🛂 
  [ 0x0001f6c3 ], // 🛃 
  [ 0x0001f6c4 ], // 🛄 
  [ 0x0001f6c5 ], // 🛅 
  [ 0x0001f6b9 ], // 🚹 
  [ 0x0001f6ba ], // 🚺 
  [ 0x0001f6bc ], // 🚼 
  [ 0x0001f6bb ], // 🚻 
  [ 0x000026A7 ], // ⚧
  [ 0x0001f6ae ], // 🚮 
  [ 0x0001f3a6 ], // 🎦 
  [ 0x0001f4f6 ], // 📶 
  [ 0x0001f201 ], // 🈁 
  [ 0x0001f523 ], // 🔣 
  [ 0x00002139, 0x0000fe0f ], // ℹ️ 
  [ 0x0001f524 ], // 🔤 
  [ 0x0001f521 ], // 🔡 
  [ 0x0001f520 ], // 🔠 
  [ 0x0001f196 ], // 🆖 
  [ 0x0001f197 ], // 🆗 
  [ 0x0001f199 ], // 🆙 
  [ 0x0001f192 ], // 🆒 
  [ 0x0001f195 ], // 🆕 
  [ 0x0001f193 ], // 🆓 
  [ 0x30, 0x0000fe0f, 0x000020e3 ], // 0️⃣ 
  [ 0x31, 0x0000fe0f, 0x000020e3 ], // 1️⃣ 
  [ 0x32, 0x0000fe0f, 0x000020e3 ], // 2️⃣ 
  [ 0x33, 0x0000fe0f, 0x000020e3 ], // 3️⃣ 
  [ 0x34, 0x0000fe0f, 0x000020e3 ], // 4️⃣ 
  [ 0x35, 0x0000fe0f, 0x000020e3 ], // 5️⃣ 
  [ 0x36, 0x0000fe0f, 0x000020e3 ], // 6️⃣ 
  [ 0x37, 0x0000fe0f, 0x000020e3 ], // 7️⃣ 
  [ 0x38, 0x0000fe0f, 0x000020e3 ], // 8️⃣ 
  [ 0x39, 0x0000fe0f, 0x000020e3 ], // 9️⃣ 
  [ 0x0001f51f ], // 🔟 
  [ 0x0001f522 ], // 🔢 
  [ 0x23, 0x0000fe0f, 0x000020e3 ], // #️⃣ 
  [ 0x2a, 0x0000fe0f, 0x000020e3 ], // *️⃣ 
  [ 0x000023CF ], // ⏏
  [ 0x000025b6, 0x0000fe0f ], // ▶️ 
  [ 0x000023f8, 0x0000fe0f ], // ⏸️ 
  [ 0x000023ef, 0x0000fe0f ], // ⏯️ 
  [ 0x000023f9, 0x0000fe0f ], // ⏹️ 
  [ 0x000023fa, 0x0000fe0f ], // ⏺️ 
  [ 0x000023ed, 0x0000fe0f ], // ⏭️ 
  [ 0x000023ee, 0x0000fe0f ], // ⏮️ 
  [ 0x000023e9 ], // ⏩ 
  [ 0x000023ea ], // ⏪ 
  [ 0x000023eb ], // ⏫ 
  [ 0x000023ec ], // ⏬ 
  [ 0x000025c0, 0x0000fe0f ], // ◀️ 
  [ 0x0001f53c ], // 🔼 
  [ 0x0001f53d ], // 🔽 
  [ 0x000027a1, 0x0000fe0f ], // ➡️ 
  [ 0x00002b05, 0x0000fe0f ], // ⬅️ 
  [ 0x00002b06, 0x0000fe0f ], // ⬆️ 
  [ 0x00002b07, 0x0000fe0f ], // ⬇️ 
  [ 0x00002197, 0x0000fe0f ], // ↗️ 
  [ 0x00002198, 0x0000fe0f ], // ↘️ 
  [ 0x00002199, 0x0000fe0f ], // ↙️ 
  [ 0x00002196, 0x0000fe0f ], // ↖️ 
  [ 0x00002195, 0x0000fe0f ], // ↕️ 
  [ 0x00002194, 0x0000fe0f ], // ↔️ 
  [ 0x000021aa, 0x0000fe0f ], // ↪️ 
  [ 0x000021a9, 0x0000fe0f ], // ↩️ 
  [ 0x00002934, 0x0000fe0f ], // ⤴️ 
  [ 0x00002935, 0x0000fe0f ], // ⤵️ 
  [ 0x0001f500 ], // 🔀 
  [ 0x0001f501 ], // 🔁 
  [ 0x0001f502 ], // 🔂 
  [ 0x0001f504 ], // 🔄 
  [ 0x0001f503 ], // 🔃 
  [ 0x0001f3b5 ], // 🎵 
  [ 0x0001f3b6 ], // 🎶 
  [ 0x00002795 ], // ➕ 
  [ 0x00002796 ], // ➖ 
  [ 0x00002797 ], // ➗ 
  [ 0x00002716, 0x0000fe0f ], // ✖️ 
  [ 0x0000267E ], // ♾ 
  [ 0x0001f4b2 ], // 💲 
  [ 0x0001f4b1 ], // 💱 
  [ 0x00002122, 0x0000fe0f ], // ™️ 
  [ 0x000000a9, 0x0000fe0f ], // ©️ 
  [ 0x000000ae, 0x0000fe0f ], // ®️ 
  [ 0x0001F441, 0x0000FE0F, 0x0000200D, 0x0001F5E8, 0x0000FE0F ], // 👁️‍🗨️
  [ 0x0001f51a ], // 🔚 
  [ 0x0001f519 ], // 🔙 
  [ 0x0001f51b ], // 🔛 
  [ 0x0001f51d ], // 🔝 
  [ 0x0001f51c ], // 🔜 
  [ 0x00003030, 0x0000fe0f ], // 〰️ 
  [ 0x000027b0 ], // ➰ 
  [ 0x000027BF ], // ➿
  [ 0x00002714, 0x0000fe0f ], // ✔️ 
  [ 0x00002611, 0x0000fe0f ], // ☑️ 
  [ 0x0001f518 ], // 🔘 
  [ 0x000026aa ], // ⚪ 
  [ 0x000026ab ], // ⚫ 
  [ 0x0001f534 ], // 🔴 
  [ 0x0001f535 ], // 🔵 
  [ 0x0001f53a ], // 🔺 
  [ 0x0001f53b ], // 🔻 
  [ 0x0001f538 ], // 🔸 
  [ 0x0001f539 ], // 🔹 
  [ 0x0001f536 ], // 🔶 
  [ 0x0001f537 ], // 🔷 
  [ 0x0001f532 ], // 🔲 
  [ 0x0001f533 ], // 🔳 
  [ 0x000025aa, 0x0000fe0f ], // ▪️ 
  [ 0x000025ab, 0x0000fe0f ], // ▫️ 
  [ 0x000025fe ], // ◾ 
  [ 0x000025fd ], // ◽ 
  [ 0x000025fc, 0x0000fe0f ], // ◼️ 
  [ 0x000025fb, 0x0000fe0f ], // ◻️ 
  [ 0x0001F7E5 ], // 🟥
  [ 0x0001F7E7 ], // 🟧
  [ 0x0001F7E8 ], // 🟨
  [ 0x0001F7E9 ], // 🟩
  [ 0x0001F7E6 ], // 🟦
  [ 0x0001F7EA ], // 🟪
  [ 0x00002b1b ], // ⬛ 
  [ 0x00002b1c ], // ⬜ 
  [ 0x0001F7EB ], // 🟫
  [ 0x0001f508 ], // 🔈 
  [ 0x0001f507 ], // 🔇 
  [ 0x0001f509 ], // 🔉 
  [ 0x0001f50a ], // 🔊 
  [ 0x0001f514 ], // 🔔 
  [ 0x0001f515 ], // 🔕 
  [ 0x0001f4e3 ], // 📣 
  [ 0x0001f4e2 ], // 📢 
  [ 0x0001f4ac ], // 💬 
  [ 0x0001f4ad ], // 💭 
  [ 0x0001f5ef, 0x0000fe0f ], // 🗯️ 
  [ 0x00002660, 0x0000fe0f ], // ♠️ 
  [ 0x00002663, 0x0000fe0f ], // ♣️ 
  [ 0x00002665, 0x0000fe0f ], // ♥️ 
  [ 0x00002666, 0x0000fe0f ], // ♦️ 
  [ 0x0001f0cf ], // 🃏 
  [ 0x0001f004 ], // 🀄 
  [ 0x0001f3b4 ], // 🎴 
  [ 0x0001f550 ], // 🕐 
  [ 0x0001f551 ], // 🕑 
  [ 0x0001f552 ], // 🕒 
  [ 0x0001f553 ], // 🕓 
  [ 0x0001f554 ], // 🕔 
  [ 0x0001f555 ], // 🕕 
  [ 0x0001f556 ], // 🕖 
  [ 0x0001f557 ], // 🕗 
  [ 0x0001f558 ], // 🕘 
  [ 0x0001f559 ], // 🕙 
  [ 0x0001f55a ], // 🕚 
  [ 0x0001f55b ], // 🕛 
  [ 0x0001f55c ], // 🕜 
  [ 0x0001f55d ], // 🕝 
  [ 0x0001f55e ], // 🕞 
  [ 0x0001f55f ], // 🕟 
  [ 0x0001f560 ], // 🕠 
  [ 0x0001f561 ], // 🕡 
  [ 0x0001f562 ], // 🕢 
  [ 0x0001f563 ], // 🕣 
  [ 0x0001f564 ], // 🕤 
  [ 0x0001f565 ], // 🕥 
  [ 0x0001f566 ], // 🕦 
  [ 0x0001f567 ] // 🕧 
]

export const arrayUnicode8 = [
  [ 0x0001f3f3, 0x0000fe0f ], // 🏳️ 
  [ 0x0001f3f4 ], // 🏴 
  [ 0x0001F3F4, 0x0000200D, 0x00002620, 0x0000FE0F ], // 🏴‍☠️
  [ 0x0001f3c1 ], // 🏁 
  [ 0x0001f6a9 ], // 🚩 
  [ 0x0001F3F3, 0x0000FE0F, 0x0000200D, 0x0001F308 ], // 🏳️‍🌈 
  [ 0x0001F3F3, 0x0000FE0F, 0x0000200D, 0x000026A7, 0x0000FE0F ], // 🏳️‍⚧️
  [ 0x0001f1fa, 0x0001f1f3 ], // 🇺🇳
  [ 0x0001f1ee, 0x0001f1f8 ], // 🇮🇸 
  [ 0x0001f1ee, 0x0001f1ea ], // 🇮🇪 
  [ 0x0001f1e6, 0x0001f1ff ], // 🇦🇿 
  [ 0x0001f1e6, 0x0001f1eb ], // 🇦🇫 
  [ 0x0001f1fa, 0x0001f1f8 ], // 🇺🇸 
  [ 0x0001f1e6, 0x0001f1ea ], // 🇦🇪 
  [ 0x0001f1e9, 0x0001f1ff ], // 🇩🇿 
  [ 0x0001f1e6, 0x0001f1f7 ], // 🇦🇷 
  [ 0x0001f1e6, 0x0001f1fc ], // 🇦🇼 
  [ 0x0001f1e6, 0x0001f1f1 ], // 🇦🇱 
  [ 0x0001f1e6, 0x0001f1f2 ], // 🇦🇲 
  [ 0x0001f1e6, 0x0001f1ee ], // 🇦🇮 
  [ 0x0001f1e6, 0x0001f1f4 ], // 🇦🇴 
  [ 0x0001f1e6, 0x0001f1ec ], // 🇦🇬 
  [ 0x0001f1e6, 0x0001f1e9 ], // 🇦🇩 
  [ 0x0001f1fe, 0x0001f1ea ], // 🇾🇪 
  [ 0x0001f1ec, 0x0001f1e7 ], // 🇬🇧 
  [ 0x0001F3F4, 0x000E0067, 0x000E0062, 0x000E0065, 0x000E006E, 0x000E0067, 0x000E007F ], // 🏴󠁧󠁢󠁥󠁮󠁧󠁿 
  [ 0x0001F3F4, 0x000E0067, 0x000E0062, 0x000E0073, 0x000E0063, 0x000E0074, 0x000E007F ], // 🏴󠁧󠁢󠁳󠁣󠁴󠁿 
  [ 0x0001F3F4, 0x000E0067, 0x000E0062, 0x000E0077, 0x000E006C, 0x000E0073, 0x000E007F ], // 🏴󠁧󠁢󠁷󠁬󠁳󠁿 
  [ 0x0001f1ee, 0x0001f1f1 ], // 🇮🇱 
  [ 0x0001f1ee, 0x0001f1f9 ], // 🇮🇹 
  [ 0x0001f1ee, 0x0001f1f6 ], // 🇮🇶 
  [ 0x0001f1ee, 0x0001f1f7 ], // 🇮🇷 
  [ 0x0001f1ee, 0x0001f1f3 ], // 🇮🇳 
  [ 0x0001f1ee, 0x0001f1e9 ], // 🇮🇩 
  [ 0x0001f1fc, 0x0001f1eb ], // 🇼🇫 
  [ 0x0001f1fa, 0x0001f1ec ], // 🇺🇬 
  [ 0x0001f1fa, 0x0001f1e6 ], // 🇺🇦 
  [ 0x0001f1fa, 0x0001f1ff ], // 🇺🇿 
  [ 0x0001f1fa, 0x0001f1fe ], // 🇺🇾 
  [ 0x0001f1ea, 0x0001f1e8 ], // 🇪🇨 
  [ 0x0001f1ea, 0x0001f1ec ], // 🇪🇬 
  [ 0x0001f1ea, 0x0001f1ea ], // 🇪🇪 
  [ 0x0001f1f8, 0x0001f1ff ], // 🇸🇿 
  [ 0x0001f1ea, 0x0001f1f9 ], // 🇪🇹 
  [ 0x0001f1ea, 0x0001f1f7 ], // 🇪🇷 
  [ 0x0001f1f8, 0x0001f1fb ], // 🇸🇻 
  [ 0x0001f1e6, 0x0001f1fa ], // 🇦🇺 
  [ 0x0001f1e6, 0x0001f1f9 ], // 🇦🇹 
  [ 0x0001f1e6, 0x0001f1fd ], // 🇦🇽 
  [ 0x0001f1f4, 0x0001f1f2 ], // 🇴🇲 
  [ 0x0001f1f3, 0x0001f1f1 ], // 🇳🇱 
  [ 0x0001f1e7, 0x0001f1f6 ], // 🇧🇶 
  [ 0x0001f1ec, 0x0001f1ed ], // 🇬🇭 
  [ 0x0001f1e8, 0x0001f1fb ], // 🇨🇻 
  [ 0x0001f1ec, 0x0001f1ec ], // 🇬🇬 
  [ 0x0001f1ec, 0x0001f1fe ], // 🇬🇾 
  [ 0x0001f1f0, 0x0001f1ff ], // 🇰🇿 
  [ 0x0001f1f6, 0x0001f1e6 ], // 🇶🇦 
  [ 0x0001f1e8, 0x0001f1e6 ], // 🇨🇦 
  [ 0x0001f1ee, 0x0001f1e8 ], // 🇮🇨 
  [ 0x0001f1ec, 0x0001f1e6 ], // 🇬🇦 
  [ 0x0001f1e8, 0x0001f1f2 ], // 🇨🇲 
  [ 0x0001f1ec, 0x0001f1f2 ], // 🇬🇲 
  [ 0x0001f1f0, 0x0001f1ed ], // 🇰🇭 
  [ 0x0001f1ec, 0x0001f1f3 ], // 🇬🇳 
  [ 0x0001f1ec, 0x0001f1fc ], // 🇬🇼 
  [ 0x0001f1e8, 0x0001f1fe ], // 🇨🇾 
  [ 0x0001f1e8, 0x0001f1fa ], // 🇨🇺 
  [ 0x0001f1e8, 0x0001f1fc ], // 🇨🇼 
  [ 0x0001f1ec, 0x0001f1f7 ], // 🇬🇷 
  [ 0x0001f1f0, 0x0001f1ee ], // 🇰🇮 
  [ 0x0001f1f0, 0x0001f1ec ], // 🇰🇬 
  [ 0x0001f1ec, 0x0001f1f9 ], // 🇬🇹 
  [ 0x0001f1ec, 0x0001f1f5 ], // 🇬🇵 
  [ 0x0001f1ec, 0x0001f1fa ], // 🇬🇺 
  [ 0x0001f1f0, 0x0001f1fc ], // 🇰🇼 
  [ 0x0001f1e8, 0x0001f1f0 ], // 🇨🇰 
  [ 0x0001f1ec, 0x0001f1f1 ], // 🇬🇱 
  [ 0x0001f1e8, 0x0001f1fd ], // 🇨🇽 
  [ 0x0001f1ec, 0x0001f1e9 ], // 🇬🇩 
  [ 0x0001f1ed, 0x0001f1f7 ], // 🇭🇷 
  [ 0x0001f1f0, 0x0001f1fe ], // 🇰🇾 
  [ 0x0001f1f0, 0x0001f1ea ], // 🇰🇪 
  [ 0x0001f1e8, 0x0001f1ee ], // 🇨🇮 
  [ 0x0001f1e8, 0x0001f1e8 ], // 🇨🇨 
  [ 0x0001f1e8, 0x0001f1f7 ], // 🇨🇷 
  [ 0x0001f1fd, 0x0001f1f0 ], // 🇽🇰 
  [ 0x0001f1f0, 0x0001f1f2 ], // 🇰🇲 
  [ 0x0001f1e8, 0x0001f1f4 ], // 🇨🇴 
  [ 0x0001f1e8, 0x0001f1ec ], // 🇨🇬 
  [ 0x0001f1e8, 0x0001f1e9 ], // 🇨🇩 
  [ 0x0001f1f8, 0x0001f1e6 ], // 🇸🇦 
  [ 0x0001f1ec, 0x0001f1f8 ], // 🇬🇸 
  [ 0x0001f1fc, 0x0001f1f8 ], // 🇼🇸 
  [ 0x0001f1e7, 0x0001f1f1 ], // 🇧🇱 
  [ 0x0001f1f8, 0x0001f1f9 ], // 🇸🇹 
  [ 0x0001f1ff, 0x0001f1f2 ], // 🇿🇲 
  [ 0x0001f1f5, 0x0001f1f2 ], // 🇵🇲 
  [ 0x0001f1f8, 0x0001f1f2 ], // 🇸🇲 
  [ 0x0001f1f8, 0x0001f1f1 ], // 🇸🇱 
  [ 0x0001f1e9, 0x0001f1ef ], // 🇩🇯 
  [ 0x0001f1ec, 0x0001f1ee ], // 🇬🇮 
  [ 0x0001f1ef, 0x0001f1ea ], // 🇯🇪 
  [ 0x0001f1ef, 0x0001f1f2 ], // 🇯🇲 
  [ 0x0001f1ec, 0x0001f1ea ], // 🇬🇪 
  [ 0x0001f1f8, 0x0001f1fe ], // 🇸🇾 
  [ 0x0001f1f8, 0x0001f1ec ], // 🇸🇬 
  [ 0x0001f1f8, 0x0001f1fd ], // 🇸🇽 
  [ 0x0001f1ff, 0x0001f1fc ], // 🇿🇼 
  [ 0x0001f1e8, 0x0001f1ed ], // 🇨🇭 
  [ 0x0001f1f8, 0x0001f1ea ], // 🇸🇪 
  [ 0x0001f1f8, 0x0001f1e9 ], // 🇸🇩 
  [ 0x0001f1ea, 0x0001f1f8 ], // 🇪🇸 
  [ 0x0001f1f8, 0x0001f1f7 ], // 🇸🇷 
  [ 0x0001f1f1, 0x0001f1f0 ], // 🇱🇰 
  [ 0x0001f1f8, 0x0001f1f0 ], // 🇸🇰 
  [ 0x0001f1f8, 0x0001f1ee ], // 🇸🇮 
  [ 0x0001f1f8, 0x0001f1e8 ], // 🇸🇨 
  [ 0x0001f1f8, 0x0001f1f3 ], // 🇸🇳 
  [ 0x0001f1f7, 0x0001f1f8 ], // 🇷🇸 
  [ 0x0001f1f0, 0x0001f1f3 ], // 🇰🇳 
  [ 0x0001f1fb, 0x0001f1e8 ], // 🇻🇨 
  [ 0x0001f1e6, 0x0001f1e8 ], // 🇦🇨 
  [ 0x0001f1f1, 0x0001f1e8 ], // 🇱🇨 
  [ 0x0001f1f8, 0x0001f1f4 ], // 🇸🇴 
  [ 0x0001f1f8, 0x0001f1e7 ], // 🇸🇧 
  [ 0x0001f1f9, 0x0001f1e8 ], // 🇹🇨 
  [ 0x0001f1f9, 0x0001f1ed ], // 🇹🇭 
  [ 0x0001f1f9, 0x0001f1ef ], // 🇹🇯 
  [ 0x0001f1f9, 0x0001f1ff ], // 🇹🇿 
  [ 0x0001f1e8, 0x0001f1ff ], // 🇨🇿 
  [ 0x0001f1f7, 0x0001f1f4 ], // 🇷🇴 
  [ 0x0001f1f9, 0x0001f1f3 ], // 🇹🇳 
  [ 0x0001f1e8, 0x0001f1f1 ], // 🇨🇱 
  [ 0x0001f1f9, 0x0001f1fb ], // 🇹🇻 
  [ 0x0001f1e9, 0x0001f1f0 ], // 🇩🇰 
  [ 0x0001f1e9, 0x0001f1ea ], // 🇩🇪 
  [ 0x0001f1f9, 0x0001f1ec ], // 🇹🇬 
  [ 0x0001f1f9, 0x0001f1f0 ], // 🇹🇰 
  [ 0x0001f1e9, 0x0001f1f4 ], // 🇩🇴 
  [ 0x0001f1e9, 0x0001f1f2 ], // 🇩🇲 
  [ 0x0001f1f9, 0x0001f1f9 ], // 🇹🇹 
  [ 0x0001f1f9, 0x0001f1f2 ], // 🇹🇲 
  [ 0x0001f1f9, 0x0001f1f7 ], // 🇹🇷 
  [ 0x0001f1f9, 0x0001f1f4 ], // 🇹🇴 
  [ 0x0001f1f3, 0x0001f1ec ], // 🇳🇬 
  [ 0x0001f1f3, 0x0001f1f7 ], // 🇳🇷 
  [ 0x0001f1f3, 0x0001f1e6 ], // 🇳🇦 
  [ 0x0001f1f3, 0x0001f1fa ], // 🇳🇺 
  [ 0x0001f1f3, 0x0001f1ee ], // 🇳🇮 
  [ 0x0001f1f3, 0x0001f1ea ], // 🇳🇪 
  [ 0x0001f1f3, 0x0001f1e8 ], // 🇳🇨 
  [ 0x0001f1f3, 0x0001f1ff ], // 🇳🇿 
  [ 0x0001f1f3, 0x0001f1f5 ], // 🇳🇵 
  [ 0x0001f1f3, 0x0001f1eb ], // 🇳🇫 
  [ 0x0001f1f3, 0x0001f1f4 ], // 🇳🇴 
  [ 0x0001f1e7, 0x0001f1ed ], // 🇧🇭 
  [ 0x0001f1ed, 0x0001f1f9 ], // 🇭🇹 
  [ 0x0001f1f5, 0x0001f1f0 ], // 🇵🇰 
  [ 0x0001f1fb, 0x0001f1e6 ], // 🇻🇦 
  [ 0x0001f1f5, 0x0001f1e6 ], // 🇵🇦 
  [ 0x0001f1fb, 0x0001f1fa ], // 🇻🇺 
  [ 0x0001f1e7, 0x0001f1f8 ], // 🇧🇸 
  [ 0x0001f1f5, 0x0001f1ec ], // 🇵🇬 
  [ 0x0001f1e7, 0x0001f1f2 ], // 🇧🇲 
  [ 0x0001f1f5, 0x0001f1fc ], // 🇵🇼 
  [ 0x0001f1f5, 0x0001f1fe ], // 🇵🇾 
  [ 0x0001f1e7, 0x0001f1e7 ], // 🇧🇧 
  [ 0x0001f1f5, 0x0001f1f8 ], // 🇵🇸 
  [ 0x0001f1ed, 0x0001f1fa ], // 🇭🇺 
  [ 0x0001f1e7, 0x0001f1e9 ], // 🇧🇩 
  [ 0x0001f1f5, 0x0001f1f3 ], // 🇵🇳 
  [ 0x0001f1eb, 0x0001f1ef ], // 🇫🇯 
  [ 0x0001f1f5, 0x0001f1ed ], // 🇵🇭 
  [ 0x0001f1eb, 0x0001f1ee ], // 🇫🇮 
  [ 0x0001f1e7, 0x0001f1f9 ], // 🇧🇹 
  [ 0x0001f1f5, 0x0001f1f7 ], // 🇵🇷 
  [ 0x0001f1eb, 0x0001f1f4 ], // 🇫🇴 
  [ 0x0001f1eb, 0x0001f1f0 ], // 🇫🇰 
  [ 0x0001f1e7, 0x0001f1f7 ], // 🇧🇷 
  [ 0x0001f1e8, 0x0001f1f5 ], // 🇨🇵 
  [ 0x0001f1e7, 0x0001f1ec ], // 🇧🇬 
  [ 0x0001f1e7, 0x0001f1eb ], // 🇧🇫 
  [ 0x0001f1e7, 0x0001f1f3 ], // 🇧🇳 
  [ 0x0001f1e7, 0x0001f1ee ], // 🇧🇮 
  [ 0x0001f1fb, 0x0001f1f3 ], // 🇻🇳 
  [ 0x0001f1e7, 0x0001f1ef ], // 🇧🇯 
  [ 0x0001f1fb, 0x0001f1ea ], // 🇻🇪 
  [ 0x0001f1e7, 0x0001f1fe ], // 🇧🇾 
  [ 0x0001f1e7, 0x0001f1ff ], // 🇧🇿 
  [ 0x0001f1f5, 0x0001f1ea ], // 🇵🇪 
  [ 0x0001f1f9, 0x0001f1e9 ], // 🇹🇩 
  [ 0x0001f1f5, 0x0001f1f1 ], // 🇵🇱 
  [ 0x0001f1e7, 0x0001f1e6 ], // 🇧🇦 
  [ 0x0001f1e7, 0x0001f1fc ], // 🇧🇼 
  [ 0x0001f1e7, 0x0001f1f4 ], // 🇧🇴 
  [ 0x0001f1f5, 0x0001f1f9 ], // 🇵🇹 
  [ 0x0001f1ed, 0x0001f1f3 ], // 🇭🇳 
  [ 0x0001f1f2, 0x0001f1ed ], // 🇲🇭 
  [ 0x0001f1f2, 0x0001f1f4 ], // 🇲🇴 
  [ 0x0001f1f2, 0x0001f1ec ], // 🇲🇬 
  [ 0x0001f1fe, 0x0001f1f9 ], // 🇾🇹 
  [ 0x0001f1f2, 0x0001f1fc ], // 🇲🇼 
  [ 0x0001f1f2, 0x0001f1f1 ], // 🇲🇱 
  [ 0x0001f1f2, 0x0001f1f9 ], // 🇲🇹 
  [ 0x0001f1f2, 0x0001f1f6 ], // 🇲🇶 
  [ 0x0001f1f2, 0x0001f1fe ], // 🇲🇾 
  [ 0x0001f1ee, 0x0001f1f2 ], // 🇮🇲 
  [ 0x0001f1eb, 0x0001f1f2 ], // 🇫🇲 
  [ 0x0001f1f2, 0x0001f1f2 ], // 🇲🇲 
  [ 0x0001f1f2, 0x0001f1fd ], // 🇲🇽 
  [ 0x0001f1f2, 0x0001f1fa ], // 🇲🇺 
  [ 0x0001f1f2, 0x0001f1f7 ], // 🇲🇷 
  [ 0x0001f1f2, 0x0001f1ff ], // 🇲🇿 
  [ 0x0001f1f2, 0x0001f1e8 ], // 🇲🇨 
  [ 0x0001f1f2, 0x0001f1fb ], // 🇲🇻 
  [ 0x0001f1f2, 0x0001f1e9 ], // 🇲🇩 
  [ 0x0001f1f2, 0x0001f1e6 ], // 🇲🇦 
  [ 0x0001f1f2, 0x0001f1f3 ], // 🇲🇳 
  [ 0x0001f1f2, 0x0001f1ea ], // 🇲🇪 
  [ 0x0001f1f2, 0x0001f1f8 ], // 🇲🇸 
  [ 0x0001f1ef, 0x0001f1f4 ], // 🇯🇴 
  [ 0x0001f1f1, 0x0001f1e6 ], // 🇱🇦 
  [ 0x0001f1f1, 0x0001f1fb ], // 🇱🇻 
  [ 0x0001f1f1, 0x0001f1f9 ], // 🇱🇹 
  [ 0x0001f1f1, 0x0001f1fe ], // 🇱🇾 
  [ 0x0001f1f1, 0x0001f1ee ], // 🇱🇮 
  [ 0x0001f1f1, 0x0001f1f7 ], // 🇱🇷 
  [ 0x0001f1e7, 0x0001f1ea ], // 🇧🇪 
  [ 0x0001f1f1, 0x0001f1fa ], // 🇱🇺 
  [ 0x0001f1f7, 0x0001f1fc ], // 🇷🇼 
  [ 0x0001f1f1, 0x0001f1f8 ], // 🇱🇸 
  [ 0x0001f1f1, 0x0001f1e7 ], // 🇱🇧 
  [ 0x0001f1f7, 0x0001f1ea ], // 🇷🇪 
  [ 0x0001f1f7, 0x0001f1fa ], // 🇷🇺 
  [ 0x0001f1ee, 0x0001f1f4 ], // 🇮🇴 
  [ 0x0001f1fb, 0x0001f1ec ], // 🇻🇬 
  [ 0x0001f1ea, 0x0001f1fa ], // 🇪🇺 
  [ 0x0001f1f0, 0x0001f1f7 ], // 🇰🇷 
  [ 0x0001f1ed, 0x0001f1f0 ], // 🇭🇰 
  [ 0x0001f1ea, 0x0001f1ed ], // 🇪🇭 
  [ 0x0001f1ec, 0x0001f1f6 ], // 🇬🇶 
  [ 0x0001f1f9, 0x0001f1fc ], // 🇹🇼 
  [ 0x0001f1e8, 0x0001f1eb ], // 🇨🇫 
  [ 0x0001f1e8, 0x0001f1f3 ], // 🇨🇳 
  [ 0x0001f1f9, 0x0001f1f1 ], // 🇹🇱 
  [ 0x0001f1ff, 0x0001f1e6 ], // 🇿🇦 
  [ 0x0001f1f8, 0x0001f1f8 ], // 🇸🇸 
  [ 0x0001f1e6, 0x0001f1f6 ], // 🇦🇶 
  [ 0x0001f1ef, 0x0001f1f5 ], // 🇯🇵 
  [ 0x0001f38c ], // 🎌 
  [ 0x0001f1ec, 0x0001f1eb ], // 🇬🇫 
  [ 0x0001f1f5, 0x0001f1eb ], // 🇵🇫 
  [ 0x0001f1f9, 0x0001f1eb ], // 🇹🇫 
  [ 0x0001f1fb, 0x0001f1ee ], // 🇻🇮 
  [ 0x0001f1e6, 0x0001f1f8 ], // 🇦🇸 
  [ 0x0001f1f2, 0x0001f1f0 ], // 🇲🇰 
  [ 0x0001f1f2, 0x0001f1f5 ], // 🇲🇵 
  [ 0x0001f1f0, 0x0001f1f5 ] // 🇰🇵 
]

export const arrayUnicodes = [
  arrayUnicode1,
  arrayUnicode2,
  arrayUnicode3,
  arrayUnicode4,
  arrayUnicode5,
  arrayUnicode6,
  arrayUnicode7,
  arrayUnicode8
]
